/* La foto del producto ya puede traer la leyenda quemada (ver la lista
   window.AVANTE_MARCADAS en assets/fotos.js). Cuando la trae, el tema NO debe
   dibujar ademas su propio <span class="pza">: saldria dos veces en la tarjeta. */
window.avanteYaMarcada = function(sk){
  var S = window.AVANTE_MARCADAS;
  return !!(S && S.has && S.has(sk));
};
(function(){
"use strict";
var mx = new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN',maximumFractionDigits:0});
/* 55 4081 9788 es el WhatsApp verificado con Meta (verified_name: Avante Moto Llantas).
   El 55 5679 2699 es la linea fija de recepcion y NO recibe WhatsApp: estaba aqui por error
   y todos los botones de WhatsApp del sitio caian en un numero que no contesta. */
var WA = '525540819788';
function waLink(text){ return 'https://wa.me/'+WA+'?text='+encodeURIComponent(text); }

/* ===== META PIXEL — los eventos que el pixel de Shopify NO puede ver ========
   QUE YA FUNCIONA SOLO (no lo tocamos, se duplicaría):
     PageView de la primera carga, ViewContent en /products/..., AddToCart (Shopify
     detecta /cart/add.js), InitiateCheckout y Purchase en el checkout. Todo eso lo
     manda la app "Facebook & Instagram" por navegador Y por servidor (CAPI).

   QUE NO PUEDE VER, Y POR ESO ESTÁ ESTE BLOQUE:
     Este sitio es UNA sola página: moverse entre Inicio, Moto, Auto, Servicios y
     Sucursal no recarga nada, y abrir la ficha de una llanta tampoco. Para Shopify
     —y por lo tanto para Meta— toda la visita es una sola vista. Resultado: Meta no
     sabe qué llanta miró la persona, no puede armar públicos de retargeting y no
     puede alimentar los anuncios dinámicos de catálogo. Aquí se lo decimos a mano.

   Y LO MÁS IMPORTANTE PARA ESTE NEGOCIO: el clic a WhatsApp.
     La mayor parte de las ventas de Avante NO cierran en el checkout, cierran en el
     chat. Si Meta sólo ve Purchase, optimiza para la rebanada chica que paga en línea
     y concluye que la campaña no sirve. Cada clic a WhatsApp manda un evento `Lead`
     CON VALOR, para que Meta pueda optimizar por lead valioso y no por lead barato.

   REGLA DE ORO: `content_ids` va con el **id de producto de Shopify** (`p.pid`) y
   content_type "product_group", porque así es exactamente como Shopify sincroniza el
   catálogo a Meta (verificado leyendo el AddToCart real que manda la app). Si se
   mandara el id de variante, el evento llega pero Meta no lo puede amarrar a ningún
   artículo del catálogo y el retargeting dinámico no arranca.

   NUNCA debe romper el sitio: si fbq no existe todavía se encola, si no llega nunca
   se descarta en silencio, y todo va dentro de try/catch. */
var META = (function(){
  var PENDIENTES = [], reintentos = 0, MAX_REINTENTOS = 40;   // 40 x 250ms = 10 s

  function listo(){ return typeof window.fbq === 'function' && window.fbq.loaded; }

  /* Si algún día se pone banner de consentimiento, esto lo respeta solo.
     Hoy la tienda no tiene la API de privacidad activa y devuelve true. */
  function permitido(){
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if(cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed();
    } catch(e){}
    return true;
  }

  function id(evt){
    return 'av-' + evt + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,8);
  }

  function enviar(evt, datos){
    try { window.fbq('track', evt, datos, {eventID: id(evt)}); } catch(e){}
  }

  function vaciar(){
    while(PENDIENTES.length){ var x = PENDIENTES.shift(); enviar(x[0], x[1]); }
  }

  function track(evt, datos){
    try {
      if(!permitido()) return;
      if(listo()){ enviar(evt, datos || {}); return; }
      PENDIENTES.push([evt, datos || {}]);
      if(reintentos === 0) esperar();
    } catch(e){}
  }

  function esperar(){
    var t = setInterval(function(){
      reintentos++;
      if(listo()){ clearInterval(t); vaciar(); }
      else if(reintentos > MAX_REINTENTOS){ clearInterval(t); PENDIENTES.length = 0; }
    }, 250);
  }

  /* Traduce un producto del catálogo del tema al formato que espera el catálogo de Meta. */
  function deProducto(p, cantidad){
    if(!p) return {};
    var q = cantidad || 1;
    var d = {
      content_type: 'product_group',
      content_name: ((p.b ? p.b + ' ' : '') + (p.n || '')).trim(),
      content_category: p.seg === 'moto' ? 'Moto' : 'Auto y camioneta',
      value: (p.p || 0) * q,
      currency: 'MXN'
    };
    if(p.pid){
      d.content_ids = [p.pid];
      d.contents = [{ id: p.pid, quantity: q, item_price: p.p || 0 }];
    }
    if(p.s) d.medida = p.s;
    return d;
  }

  return { track: track, deProducto: deProducto };
})();


/* ===== Escapado de salida =================================================
   Todo texto que NO sea literal de este archivo pasa por esc() antes de
   concatenarse dentro de HTML. Los datos vienen de Shopify y del Google Sheet
   (catalog-data.js, moto-ficha.json, fotos.js, promos.js, resenas-google.json):
   son nuestros, pero NO son constantes. Un "<" o una comilla en el nombre de un
   modelo rompe el markup, y las opiniones de Google las escriben terceros.
   safeUrl() además exige https:// en cualquier URL que venga de un dato, para
   que un "javascript:" nunca llegue a un href. */
/* --- la foto del producto, o el ícono ------------------------------------
   El mismo par de decisiones (¿hay foto para este SKU? ¿con qué ancho y qué
   `sizes` la pido?) se repetía en cada tarjeta, y en dos lugares — el top del
   home y la miniatura del carrito — simplemente no se tomaba: pintaban el
   ícono aunque la foto existiera. shotHTML centraliza las dos ramas para que
   un lugar nuevo no pueda volver a olvidarse. Vive junto a esc() y srcset()
   porque las usa. `rot` sólo aplica al ícono: girar una foto real no aporta. */
function fotoDe(p){
  return (p && window.AVANTE_FOTOS && (window.AVANTE_FOTOS[p.sk]||[])[0]) || '';
}
function shotHTML(p, alt, ancho, sizes, rot){
  var f = fotoDe(p);
  if(f) return '<img class="cardfoto" src="'+esc(f)+'&width='+ancho+'"'
    + ' srcset="'+srcset(f,[180,260,400,540])+'"'
    + ' sizes="'+sizes+'"'
    + ' alt="'+esc(alt)+'" loading="lazy" decoding="async">';
  return '<svg viewBox="0 0 120 120"'+(rot?' style="transform:rotate('+rot+'deg)"':'')+'><use href="'+((p&&p.seg==='moto')?'#tiremoto':'#tire')+'"/></svg>';
}

/* --- srcset para las fotos del CDN de Shopify ------------------------------
   El CDN acepta &width=N y devuelve la imagen ya redimensionada. Antes se pedía
   siempre un ancho fijo (400 en las tarjetas), así que en un celular se bajaban
   400 px para pintar 170, y en una pantalla retina se veía suave. srcset deja
   que el navegador elija; `sizes` le dice de antemano cuánto va a medir el hueco
   para que no adivine mal antes de tener el CSS. */
function srcset(u, anchos){
  return anchos.map(function(w){ return esc(u)+'&width='+w+' '+w+'w'; }).join(', ');
}

function esc(v){
  return String(v == null ? '' : v)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function safeUrl(u){
  var s = String(u == null ? '' : u).trim();
  return /^https:\/\//i.test(s) ? esc(s) : '';
}

/* ===== CATÁLOGO real — inyectado por assets/catalog-data.js (generado desde Shopify) =====
   catalog-data.js define window.AVANTE_MOTO y window.AVANTE_AUTO con el inventario real
   (369 motos, 1,341 auto+camioneta). Se regenera con shopify-theme/build_theme_data.py cada
   vez que cambie el catálogo — ver ese script para el detalle del mapeo. */
var MOTO = window.AVANTE_MOTO || [];
MOTO.forEach(function(p,i){ p.seg='moto'; p.id='m'+i; });

var AUTO = window.AVANTE_AUTO || [];
AUTO.forEach(function(p,i){ p.seg='auto'; p.id='a'+i; });

/* ===== navegación entre vistas (con rutas reales) ===== */
var TITLES = {
  home:'Avante Miramontes | Llantas para auto, camioneta y moto en CDMX',
  auto:'Llantas para auto y camioneta | Avante Miramontes',
  moto:'Llantas para moto | Avante Miramontes',
  servicios:'Montaje, balanceo y alineación | Avante Miramontes',
  sucursal:'Sucursal, envíos y pagos | Avante Miramontes'
};
/* Desde que cada URL sirve SOLO su vista (ver el comentario en avante-app.liquid), la vista
   destino puede simplemente no existir en este documento. Cuando pasa, go() no tiene nada que
   mostrar: devuelve false y quien lo llamó deja que el navegador navegue de verdad. */
function vistaExiste(name){ return !!document.querySelector('.view[data-view="'+name+'"]'); }

/* ===== AISLAMIENTO DE BLOQUES ==============================================
   Desde que cada URL sirve SOLO su vista, la mitad de los elementos del DOM no
   existen en un documento dado. Antes, todo este archivo era un solo IIFE: un
   `document.getElementById('homeBrands').innerHTML = ...` sobre null tiraba
   TypeError y MATABA TODO EL RESTO DEL ARCHIVO — así fue como el primer intento
   de partir las vistas dejó la portada con los selectores del buscador vacíos y
   la navegación muerta, sin un solo error visible para el usuario.

   bloque() encierra cada pieza independiente. Si una falla, las demás siguen
   vivas y el problema queda escrito en la consola en vez de tumbar el sitio.
   No sustituye a las guardas explícitas: es la red debajo del trapecio. */
function bloque(nombre, fn){
  try { fn(); }
  catch(e){
    if(window.console && console.warn) console.warn('[avante] el bloque "'+nombre+'" no arrancó:', e && e.message);
  }
}
/* getElementById con nombre corto; devuelve null sin ruido si no está. */
function $id(id){ return document.getElementById(id); }

/* Filtros por la URL. Al partir las vistas ya no hay memoria compartida entre
   la portada y el catálogo: el buscador del inicio tiene que NAVEGAR de verdad
   a /pages/auto y llevarse los filtros escritos en la dirección. De paso, cada
   búsqueda queda en una URL que se puede compartir y a la que Google puede llegar. */
function qsFiltros(o){
  var q = [];
  Object.keys(o).forEach(function(k){
    if(o[k] !== undefined && o[k] !== null && o[k] !== '') q.push(k+'='+encodeURIComponent(o[k]));
  });
  return q.length ? '?'+q.join('&') : '';
}
function leerFiltrosDeURL(){
  var o = {}, qs = (location.search||'').replace(/^\?/,'');
  if(!qs) return o;
  qs.split('&').forEach(function(par){
    var kv = par.split('=');
    if(kv[0]) o[kv[0]] = decodeURIComponent((kv[1]||'').replace(/\+/g,' '));
  });
  return o;
}

function go(name, push){
  if(!vistaExiste(name)) return false;
  document.querySelectorAll('.view').forEach(function(v){ v.classList.toggle('on', v.dataset.view===name); });
  document.querySelectorAll('nav.main a, .mininav a').forEach(function(b){ b.classList.toggle('on', b.dataset.go===name); });
  window.scrollTo({top:0,behavior:'instant' in window ? 'auto' : 'auto'});
  if(name==='sucursal'){ setTimeout(drawMap,30); }
  var logoImg = document.getElementById('headerLogo');
  if(logoImg){ logoImg.src = (name==='moto') ? logoImg.dataset.logoMoto : logoImg.dataset.logoDefault; }
  /* Entrar a Auto o Moto por el menú siempre cae en la portada de esa sección.
     Los buscadores (el del home y el de la propia portada) llaman showCat(seg,true)
     después de go(), y por eso sí aterrizan directo en el catálogo filtrado. */
  if(window.AVANTE_showCat && (name==='auto' || name==='moto')) window.AVANTE_showCat(name, false);
  observeReveals();
  if(TITLES[name]) document.title = TITLES[name];
  if(push !== false && window.history && history.pushState){
    try { history.pushState({v:name}, '', name==='home' ? '/' : '/pages/'+name); } catch(e){}
    /* Sólo cuando el usuario navega de verdad. En el arranque go() se llama con
       push=false, y ahí Shopify ya mandó su propio PageView: duplicarlo inflaría
       las métricas y ensuciaría la optimización. */
    META.track('PageView', {seccion: name});
  }
  return true;
}
window.addEventListener('popstate', function(e){
  var n = (e.state && e.state.v) || routeFromPath();
  go(n, false);
  META.track('PageView', {seccion: n, via: 'atras'});
});
function routeFromPath(){
  /* las vistas viven como Páginas reales de Shopify: /pages/auto, /pages/moto, etc. */
  var seg = (location.pathname||'/').replace(/^\/+|\/+$/g,'').toLowerCase();
  seg = seg.replace(/^pages\//,'');
  if(seg==='camioneta') seg='auto';
  if(seg==='envios' || seg==='contacto') seg='sucursal';
  return ['auto','moto','servicios','sucursal'].indexOf(seg)>=0 ? seg : 'home';
}
document.addEventListener('click', function(e){
  var t = e.target.closest('[data-go]');
  if(!t) return;
  /* Solo interceptamos el clic si de verdad podemos mostrar esa vista aqui. Si no esta en este
     documento, NO se llama preventDefault y el <a> hace lo que siempre debio hacer: navegar.
     Por eso cada enlace conserva su href real -- si algun dia se quita el JS, el sitio sigue
     funcionando como un sitio de toda la vida. */
  if(!vistaExiste(t.dataset.go)) return;
  e.preventDefault();
  go(t.dataset.go);
});

/* ===== tabs del buscador ===== */
var tabs = document.querySelectorAll('.finder .tabs button');
tabs.forEach(function(t){
  t.addEventListener('click', function(){
    tabs.forEach(function(x){ x.setAttribute('aria-selected','false'); });
    t.setAttribute('aria-selected','true');
    document.querySelectorAll('.panel').forEach(function(p){
      if(p.dataset.panel===t.dataset.tab) p.setAttribute('data-open',''); else p.removeAttribute('data-open');
    });
  });
});

/* ===== catálogo genérico ===== */
function Catalog(opts){
  var data = opts.data, state = {brands:[], rins:[], usos:[], mbs:[], ccs:[], max:null, q:'', sort:'rel'};
  var elFilters = document.getElementById(opts.filters),
      elGrid = document.getElementById(opts.grid),
      elCount = document.getElementById(opts.count),
      elTags = document.getElementById(opts.tags),
      elSearch = document.getElementById(opts.search),
      elSort = document.getElementById(opts.sort);

  /* Esta vista puede no estar en este documento (ej. el catálogo de auto cuando
     estamos en /pages/moto). Aun así hay que devolver un objeto usable: el
     carrito y la ficha de producto llaman a find() desde CUALQUIER ruta para
     resolver un producto por su id. Lo único que se apaga es la interfaz. */
  if(!elFilters || !elGrid || !elTags){
    return {
      sinVista: true,
      setBrand: function(){}, setFrom: function(){},
      find: function(id){ return data.filter(function(p){ return p.id===id; })[0]; },
      motoBrandOptions: function(){
        var m={}; data.forEach(function(p){ (p.mb||[]).forEach(function(v){ m[v]=1; }); });
        return Object.keys(m).filter(Boolean).sort();
      },
      ccOptions: function(){
        var ORDER = ['Hasta 125 cc','126 a 250 cc','251 a 500 cc','501 a 800 cc','Más de 800 cc'], m={};
        data.forEach(function(p){ (p.cc||[]).forEach(function(v){ m[v]=1; }); });
        return ORDER.filter(function(c){ return m[c]; });
      }
    };
  }
  var maxPrice = Math.max.apply(null, data.map(function(p){ return p.p; }));
  state.max = maxPrice;

  function uniq(key){ var m={}; data.forEach(function(p){ m[p[key]] = (m[p[key]]||0)+1; }); return m; }
  /* Igual que uniq pero para campos que son ARREGLO (mb = marcas de moto compatibles,
     cc = rangos de cilindrada). Una misma llanta le queda a varias marcas/cilindradas. */
  function uniqArr(key){ var m={}; data.forEach(function(p){ (p[key]||[]).forEach(function(v){ m[v]=(m[v]||0)+1; }); }); return m; }
  var brands = uniq('b'), rins = uniq('r'), usos = uniq('u');
  var motoBrands = uniqArr('mb'), ccs = uniqArr('cc');
  var CC_ORDER = ['Hasta 125 cc','126 a 250 cc','251 a 500 cc','501 a 800 cc','Más de 800 cc'];
  function ccSorted(){ return CC_ORDER.filter(function(c){ return ccs[c]; }); }

  /* Cada grupo es un <details> colapsable. Motivo real: con Marca de llanta (hasta 76
     opciones), Marca de moto (26), Rin, Uso, Cilindrada y Precio, la barra lateral quedaba
     MÁS ALTA QUE LA PANTALLA. Un `position:sticky` más alto que la ventana se pega por
     arriba y deja el resto fuera de alcance: había que bajar todo el catálogo para llegar
     a los últimos filtros. Con los grupos largos cerrados por default, todo cabe de un
     vistazo; y como red de seguridad el CSS le da scroll propio a la barra en escritorio.
     Los grupos que ya traen un filtro puesto (por ejemplo al llegar desde el buscador de
     la portada) se abren solos, para que se vea por qué está filtrado. */
  function grupo(titulo, contenido, abierto, buscador){
    return '<details class="fgroup"'+(abierto?' open':'')+'>'
      + '<summary><span>'+titulo+'</span><i class="cnt" data-cnt="'+titulo+'"></i></summary>'
      + (buscador ? '<input class="fsearch" type="search" placeholder="Buscar '+titulo.toLowerCase()+'" aria-label="Buscar en '+titulo+'">' : '')
      + contenido + '</details>';
  }

  function buildFilters(){
    var h = '';

    var brandBoxes = Object.keys(brands).sort().map(function(b){
      return '<label class="check"><input type="checkbox" data-k="brands" value="'+esc(b)+'"><span>'+esc(b)+'</span><span class="n">'+brands[b]+'</span></label>';
    }).join('');
    h += grupo(opts.brandLabel||'Marca', '<div class="checks">'+brandBoxes+'</div>',
               state.brands.length>0, Object.keys(brands).length>10);

    /* Se descarta el rin 0: no existe una llanta de rin 0". Aparece cuando una fila del
       catálogo viene sin la columna "medida" y el parser no tuvo de dónde sacarlo, y en
       la barra de filtros se veía como una pastilla 0" que no le sirve a nadie. Se filtra
       aquí en vez de en los datos porque el dato hay que arreglarlo en el origen, no
       taparlo — pero mientras tanto el filtro no debe mostrar basura. */
    var rinPills = Object.keys(rins).map(Number).filter(function(r){ return r > 0; })
      .sort(function(a,b){return a-b;}).map(function(r){
      return '<button class="pill" data-k="rins" data-v="'+r+'">'+r+'"</button>';
    }).join('');
    h += grupo('Rin', '<div class="pills">'+rinPills+'</div>', true, false);

    var usoKeys = Object.keys(usos).filter(Boolean);
    if(usoKeys.length){
      var usoBoxes = usoKeys.sort().map(function(u){
        return '<label class="check"><input type="checkbox" data-k="usos" value="'+esc(u)+'"><span>'+esc(u)+'</span><span class="n">'+usos[u]+'</span></label>';
      }).join('');
      h += grupo(opts.usoLabel||'Uso', '<div class="checks">'+usoBoxes+'</div>', true, false);
    }

    /* Filtros que sólo existen en el catálogo de moto: salen de la ficha técnica real
       (Fichas_maestro). mb/cc son arreglos, por eso van con uniqArr y con indexOf sobre
       el arreglo del producto, no con comparación directa. */
    var mbKeys = Object.keys(motoBrands).filter(Boolean);
    if(mbKeys.length){
      var mbBoxes = mbKeys.sort().map(function(m){
        return '<label class="check"><input type="checkbox" data-k="mbs" value="'+esc(m)+'"><span>'+esc(m)+'</span><span class="n">'+motoBrands[m]+'</span></label>';
      }).join('');
      h += grupo('Marca de moto', '<div class="checks">'+mbBoxes+'</div>',
                 state.mbs.length>0, mbKeys.length>10);
    }
    var ccKeys = ccSorted();
    if(ccKeys.length){
      var ccBoxes = ccKeys.map(function(c){
        return '<label class="check"><input type="checkbox" data-k="ccs" value="'+esc(c)+'"><span>'+esc(c)+'</span><span class="n">'+ccs[c]+'</span></label>';
      }).join('');
      h += grupo('Cilindrada', '<div class="checks">'+ccBoxes+'</div>', true, false);
    }

    h += grupo('Precio máximo',
          '<input type="range" id="'+opts.grid+'Range" min="400" max="'+maxPrice+'" step="50" value="'+maxPrice+'" aria-label="Precio máximo por llanta">'
        + '<div class="rangebox"><span>$400</span><b id="'+opts.grid+'RangeVal" style="color:var(--ink)">'+mx.format(maxPrice)+'</b></div>',
          true, false)
       + '<div class="fgroup plain"><button class="btn ghost sm" style="width:100%" data-clear>Limpiar filtros</button></div>';
    elFilters.innerHTML = h;

    elFilters.addEventListener('change', function(e){
      var i = e.target.closest('input[type=checkbox]');
      if(i){
        var arr = state[i.dataset.k];
        if(i.checked){ if(arr.indexOf(i.value)<0) arr.push(i.value); }
        else { var ix = arr.indexOf(i.value); if(ix>=0) arr.splice(ix,1); }
        render();
      }
    });
    elFilters.addEventListener('input', function(e){
      if(e.target.type==='range'){
        state.max = +e.target.value;
        document.getElementById(opts.grid+'RangeVal').textContent = mx.format(state.max);
        render();
      }
      /* buscador dentro de un grupo largo: esconde las opciones que no coinciden */
      if(e.target.classList.contains('fsearch')){
        var q = e.target.value.toLowerCase().trim();
        e.target.parentNode.querySelectorAll('.check').forEach(function(l){
          l.hidden = q && l.textContent.toLowerCase().indexOf(q) < 0;
        });
      }
    });
    elFilters.addEventListener('click', function(e){
      var p = e.target.closest('.pill');
      if(p){
        var arr = state.rins, v = p.dataset.v, ix = arr.indexOf(v);
        if(ix<0){ arr.push(v); p.classList.add('on'); } else { arr.splice(ix,1); p.classList.remove('on'); }
        render(); return;
      }
      if(e.target.closest('[data-clear]')) clearAll();
    });
  }

  /* ===== La hoja de filtros del celular ==================================
     Qué problema resuelve: medido en un iPhone de 390x780, la columna de filtros
     ocupaba 1,040 px abierta y 356 px cerrada — o sea, la primera llanta aparecía
     a 1,558 px del inicio, dos pantallas abajo. Quien entraba al catálogo veía
     filtros, no producto.

     Cómo se resuelve: NO se cambia el marcado ni se duplica nada. El mismo
     <aside class="filters"> se convierte por CSS en una hoja fija abajo, y aquí
     sólo se le agrega su cabecera, su pie y el botón que la abre. En escritorio
     todo esto está en display:none y el comportamiento es idéntico al de antes.

     Se monta siempre (no sólo si la pantalla es angosta) a propósito: si se
     montara según el ancho, girar el teléfono o abrir el sitio en una ventana
     angosta de escritorio dejaría un catálogo sin forma de filtrar. Es el CSS,
     no el JS, quien decide cuándo se ve — que es la regla correcta. */
  var hoja = { abierta:false, btn:null, scrim:null, ver:null, cnt:null };

  function hojaMovil(){
    if(!elFilters) return;
    var toolbar = elGrid.parentNode.querySelector('.toolbar');
    var right = toolbar && toolbar.querySelector('.right');
    if(!right) return;

    /* cabecera y pie dentro de la propia hoja */
    var head = document.createElement('div');
    head.className = 'fsheet-head';
    head.innerHTML = '<b>Filtros</b>'
      + '<button type="button" class="seclink" data-clear>Limpiar</button>'
      + '<button type="button" class="fsheet-x" aria-label="Cerrar filtros">&times;</button>';
    var grab = document.createElement('div');
    grab.className = 'fsheet-grab';
    var foot = document.createElement('div');
    foot.className = 'fsheet-foot';
    foot.innerHTML = '<button type="button" class="btn fsheet-ver">Ver resultados</button>';
    elFilters.insertBefore(head, elFilters.firstChild);
    elFilters.insertBefore(grab, elFilters.firstChild);
    elFilters.appendChild(foot);
    hoja.ver = foot.querySelector('.fsheet-ver');

    /* el botón que la abre, dentro de la barra de herramientas */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'filtbtn';
    btn.setAttribute('aria-expanded','false');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h18M6 12h12M10 19h4"/></svg>'
      + '<span>Filtros</span><i class="cnt" hidden></i>';
    right.insertBefore(btn, right.firstChild);
    hoja.btn = btn;
    hoja.cnt = btn.querySelector('.cnt');

    /* el velo. Uno por catálogo, no compartido: auto y moto nunca conviven
       en el mismo documento desde que las vistas están partidas. */
    var scrim = document.createElement('div');
    scrim.className = 'scrim';
    document.body.appendChild(scrim);
    hoja.scrim = scrim;

    btn.addEventListener('click', function(){ abrirHoja(true); });
    scrim.addEventListener('click', function(){ abrirHoja(false); });
    head.querySelector('.fsheet-x').addEventListener('click', function(){ abrirHoja(false); });
    hoja.ver.addEventListener('click', function(){ abrirHoja(false); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && hoja.abierta) abrirHoja(false); });
  }

  function abrirHoja(on){
    if(!hoja.scrim || hoja.abierta === on) return;
    hoja.abierta = on;
    elFilters.classList.toggle('on', on);
    hoja.scrim.classList.toggle('on', on);
    if(hoja.btn) hoja.btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    document.body.style.overflow = on ? 'hidden' : '';
    if(on) elFilters.scrollTop = 0;
  }

  /* Contador de seleccionados junto al título del grupo, para que se note que un grupo
     cerrado sí trae filtros puestos. */
  function pintarContadores(){
    var mapa = {};
    mapa[opts.brandLabel||'Marca'] = state.brands.length;
    mapa['Rin'] = state.rins.length;
    mapa[opts.usoLabel||'Uso'] = state.usos.length;
    mapa['Marca de moto'] = state.mbs.length;
    mapa['Cilindrada'] = state.ccs.length;
    elFilters.querySelectorAll('.cnt').forEach(function(i){
      var n = mapa[i.dataset.cnt] || 0;
      i.textContent = n ? n : '';
      i.hidden = !n;
    });
  }

  function clearAll(){
    state.brands=[]; state.rins=[]; state.usos=[]; state.mbs=[]; state.ccs=[]; state.q=''; state.max=maxPrice;
    elFilters.querySelectorAll('input[type=checkbox]').forEach(function(i){ i.checked=false; });
    elFilters.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('on'); });
    var rg = document.getElementById(opts.grid+'Range'); if(rg){ rg.value = maxPrice; document.getElementById(opts.grid+'RangeVal').textContent = mx.format(maxPrice); }
    if(elSearch) elSearch.value='';
    render();
  }

  function filtered(){
    var q = state.q.toLowerCase().trim();
    var out = data.filter(function(p){
      if(state.brands.length && state.brands.indexOf(p.b)<0) return false;
      if(state.rins.length && state.rins.indexOf(String(p.r))<0) return false;
      if(state.usos.length && state.usos.indexOf(p.u)<0) return false;
      if(state.mbs.length && !state.mbs.some(function(m){ return (p.mb||[]).indexOf(m)>=0; })) return false;
      if(state.ccs.length && !state.ccs.some(function(c){ return (p.cc||[]).indexOf(c)>=0; })) return false;
      if(p.p > state.max) return false;
      if(q && (p.b+' '+p.n+' '+p.s+' '+p.u+' '+(p.mo||'')).toLowerCase().indexOf(q)<0) return false;
      return true;
    });
    if(state.sort==='asc') out.sort(function(a,b){return a.p-b.p;});
    else if(state.sort==='desc') out.sort(function(a,b){return b.p-a.p;});
    else if(state.sort==='rin') out.sort(function(a,b){return a.r-b.r;});
    else out.sort(function(a,b){return b.st-a.st;});
    return out;
  }

  function tagHTML(){
    var t = [];
    state.brands.forEach(function(b){ t.push('<span class="tagf">'+b+'<button data-rm="brands" data-v="'+b+'">×</button></span>'); });
    state.rins.forEach(function(r){ t.push('<span class="tagf">Rin '+r+'"<button data-rm="rins" data-v="'+r+'">×</button></span>'); });
    state.usos.forEach(function(u){ t.push('<span class="tagf">'+u+'<button data-rm="usos" data-v="'+u+'">×</button></span>'); });
    state.mbs.forEach(function(m){ t.push('<span class="tagf">Moto: '+m+'<button data-rm="mbs" data-v="'+m+'">×</button></span>'); });
    state.ccs.forEach(function(c){ t.push('<span class="tagf">'+c+'<button data-rm="ccs" data-v="'+c+'">×</button></span>'); });
    if(state.max < maxPrice) t.push('<span class="tagf">Hasta '+mx.format(state.max)+'<button data-rm="max">×</button></span>');
    if(t.length) t.push('<button class="seclink" data-clear style="margin-left:4px">Limpiar todo</button>');
    return t.join('');
  }

  function render(){
    pintarContadores();
    var list = filtered();
    elCount.innerHTML = '<b>'+list.length+'</b> ' + (list.length===1?'modelo':'modelos') + ' de ' + data.length;
    /* El botón de la hoja tiene que decir CUÁNTOS filtros hay puestos: si no, con la
       hoja cerrada la persona ve 70 de 369 modelos y no entiende por qué. Y el botón
       del pie dice cuántos resultados le va a dejar lo que acaba de escoger, que es
       lo único que de verdad quiere saber antes de cerrar. */
    var puestos = state.brands.length + state.rins.length + state.usos.length
                + state.mbs.length + state.ccs.length + (state.max < maxPrice ? 1 : 0);
    if(hoja.cnt){ hoja.cnt.textContent = puestos ? puestos : ''; hoja.cnt.hidden = !puestos; }
    if(hoja.ver){
      hoja.ver.textContent = list.length
        ? 'Ver ' + list.length + (list.length===1 ? ' llanta' : ' llantas')
        : 'Nada con esos filtros';
    }
    elTags.innerHTML = tagHTML();
    if(!list.length){
      elGrid.innerHTML = '<div class="empty" style="grid-column:1/-1"><b>Nada con esos filtros.</b><br>Prueba quitar alguno o escríbenos por WhatsApp y lo conseguimos.</div>';
      return;
    }
    elGrid.innerHTML = list.map(function(p,i){
      var low = p.st <= 2;
      /* foto real rescatada de la tienda vieja, cuando este SKU tiene; si no, el ícono */
      var foto = (window.AVANTE_FOTOS && window.AVANTE_FOTOS[p.sk] || [])[0];
      return '<article class="card" style="animation-delay:'+Math.min(i*18,300)+'ms">'
        + '<div class="shot'+(foto?' hasfoto':'')+'">'
        + (p.quote ? '<span class="badge">Sobre pedido</span>'
                   : (p.pc && p.pc > p.p ? '<span class="badge hot">-'+Math.round((1-p.p/p.pc)*100)+'%</span>'
                                          : (low ? '<span class="badge hot">Últimas '+p.st+'</span>' : '')))
        + (foto ? '<img class="cardfoto" src="'+esc(foto)+'&width=400"'
                   + ' srcset="'+srcset(foto,[180,260,400,540])+'"'
                   + ' sizes="(max-width:600px) 45vw, (max-width:1100px) 30vw, 260px"'
                   + ' alt="'+esc(p.b+' '+p.n+' '+p.s)+'" loading="lazy" decoding="async">'
                : '<svg viewBox="0 0 120 120" style="transform:rotate('+((i*29)%360)+'deg)"><use href="'+(p.seg==='moto'?'#tiremoto':'#tire')+'"/></svg>')
        + '<span class="verdet">Ver detalle</span>'
        + (p.quote || (foto && window.avanteYaMarcada(p.sk)) ? '' : '<span class="pza">1 pieza · sin rin</span>')+'</div>'
        + '<div class="body">'
        + '<span class="brand">'+esc(p.b||'—')+(p.u?' · '+esc(p.u):'')+(p.suc?' · '+esc(p.suc):'')+'</span>'
        + '<span class="name">'+esc(p.n)+'</span>'
        + '<span class="size">'+esc(p.s)+'</span>'
        + (p.mo ? '<span class="fits" style="display:block;font-size:11.5px;color:var(--muted);margin-top:2px">Le queda a: '+esc(p.mo.length>70?p.mo.slice(0,70)+'…':p.mo)+'</span>' : '')
        + '<span class="stock'+(low?' low':'')+'"><i></i>'+(p.quote?'Bajo pedido':(low?'Quedan '+p.st:'En existencia ('+p.st+')'))+'</span>'
        + (p.quote
            ? '<span class="price"><b style="font-size:14px;letter-spacing:.04em">Cotiza tu medida</b></span>'
              + '<a class="add" style="display:grid;place-items:center;text-decoration:none" target="_blank" rel="noopener noreferrer" href="'+waLink('Hola Avante, quiero cotizar la llanta '+p.b+' '+p.n+' '+p.s+' para mi auto.')+'">Cotizar por WhatsApp</a>'
            : '<span class="price">'+(p.pc && p.pc>p.p ? '<s>'+mx.format(p.pc)+'</s> ' : '')+'<b>'+mx.format(p.p)+'</b><em class="unit">precio por 1 pieza</em></span>'
              + '<button class="add" data-add="'+p.id+'">Agregar</button>')
        + '</div></article>';
    }).join('');
  }

  elTags.addEventListener('click', function(e){
    var b = e.target.closest('[data-rm]');
    if(b){
      var k = b.dataset.rm;
      if(k==='max'){ state.max = maxPrice; var rg=document.getElementById(opts.grid+'Range'); if(rg) rg.value=maxPrice; document.getElementById(opts.grid+'RangeVal').textContent=mx.format(maxPrice); }
      else {
        var arr = state[k], ix = arr.indexOf(b.dataset.v); if(ix>=0) arr.splice(ix,1);
        elFilters.querySelectorAll('input[value="'+b.dataset.v+'"]').forEach(function(i){ i.checked=false; });
        elFilters.querySelectorAll('.pill[data-v="'+b.dataset.v+'"]').forEach(function(p){ p.classList.remove('on'); });
      }
      render(); return;
    }
    if(e.target.closest('[data-clear]')) clearAll();
  });
  if(elSearch) elSearch.addEventListener('input', function(){ state.q = elSearch.value; render(); });
  if(elSort) elSort.addEventListener('change', function(){ state.sort = elSort.value; render(); });

  buildFilters(); hojaMovil(); render();

  return {
    setBrand: function(b){
      clearAll();
      state.brands = [b];
      elFilters.querySelectorAll('input[value="'+b+'"]').forEach(function(i){ i.checked = true; });
      render();
    },
    setFrom: function(o){
      clearAll();
      function abrir(t){
        elFilters.querySelectorAll('.fgroup').forEach(function(d){
          var s2 = d.querySelector('summary span');
          if(s2 && s2.textContent === t) d.open = true;
        });
      }
      if(o.uso){ state.usos=[o.uso]; elFilters.querySelectorAll('input[value="'+o.uso+'"]').forEach(function(i){i.checked=true;}); }
      if(o.rin){ state.rins=[o.rin]; elFilters.querySelectorAll('.pill[data-v="'+o.rin+'"]').forEach(function(p){p.classList.add('on');}); }
      if(o.marca){ state.brands=[o.marca]; elFilters.querySelectorAll('input[value="'+o.marca+'"]').forEach(function(i){i.checked=true;}); abrir(opts.brandLabel||'Marca'); }
      if(o.motomarca){ state.mbs=[o.motomarca]; elFilters.querySelectorAll('input[data-k="mbs"][value="'+o.motomarca+'"]').forEach(function(i){i.checked=true;}); abrir('Marca de moto'); }
      if(o.cc){ state.ccs=[o.cc]; elFilters.querySelectorAll('input[data-k="ccs"][value="'+o.cc+'"]').forEach(function(i){i.checked=true;}); }
      if(o.q){ state.q=o.q; if(elSearch) elSearch.value=o.q; }
      render();
    },
    find: function(id){ return data.filter(function(p){ return p.id===id; })[0]; },
    motoBrandOptions: function(){ return Object.keys(motoBrands).filter(Boolean).sort(); },
    ccOptions: function(){ return ccSorted(); }
  };
}

var catMoto = Catalog({data:MOTO, filters:'motoFilters', grid:'motoGrid', count:'motoCount', tags:'motoTags', search:'motoSearch', sort:'motoSort', brandLabel:'Marca de llanta'});
var catAuto = Catalog({data:AUTO, filters:'autoFilters', grid:'autoGrid', count:'autoCount', tags:'autoTags', search:'autoSearch', sort:'autoSort', usoLabel:'Categoría'});

/* ===== buscadores de la portada — opciones reales, sacadas del catálogo real ===== */
function fillSelect(el, values, opts){
  opts = opts || {};
  var html = opts.placeholder ? '<option value="">'+opts.placeholder+'</option>' : '';
  html += values.map(function(v){
    var sel = (opts.selected!=null && String(v)===String(opts.selected)) ? ' selected' : '';
    return '<option'+sel+'>'+esc(v)+'</option>';
  }).join('');
  el.innerHTML = html;
}
bloque('buscador-auto', function(){
  var elA = $id('f-ancho'), elP = $id('f-perfil'), elR = $id('f-rin'), elC = $id('f-cat'), btn = $id('autoFind');
  if(!elA || !elP || !elR || !btn) return;     // este documento no trae la portada
  var anchos = Object.keys(AUTO.reduce(function(m,p){ if(p.an) m[p.an]=1; return m; },{})).map(Number).sort(function(a,b){return a-b;});
  var perfiles = Object.keys(AUTO.reduce(function(m,p){ if(p.pf) m[p.pf]=1; return m; },{})).map(Number).sort(function(a,b){return a-b;});
  var rines = Object.keys(AUTO.reduce(function(m,p){ if(p.r) m[p.r]=1; return m; },{})).map(Number).sort(function(a,b){return a-b;});
  fillSelect(elA, anchos, {selected:205});
  fillSelect(elP, perfiles, {selected:55});
  fillSelect(elR, rines.map(function(r){return 'R'+r;}), {selected:'R16'});

  /* OJO: este botón es un <a href="/pages/auto">, no un <button>. Se mantiene así a
     propósito para que el sitio funcione sin JavaScript. Como consecuencia, el enlace
     navega SOLO con su href — si no lo mantenemos al día, la búsqueda se pierde en el
     camino y el usuario aterriza en el catálogo completo. Por eso el href se reescribe
     cada vez que cambia un select, en vez de armar la URL apenas en el clic. Beneficio
     extra: el enlace se puede copiar, compartir y abrir en pestaña nueva ya filtrado. */
  function filtrosActuales(){
    return { ancho: elA.value, perfil: elP.value,
             rin: elR.value.replace(/\D/g,''), cat: elC ? elC.value : '' };
  }
  function sincronizarHref(){
    if(btn.tagName === 'A') btn.href = '/pages/auto' + qsFiltros(filtrosActuales());
  }
  [elA, elP, elR, elC].forEach(function(el){ if(el) el.addEventListener('change', sincronizarHref); });
  sincronizarHref();

  btn.addEventListener('click', function(e){
    var f = filtrosActuales();
    /* Si el catálogo de auto vive en ESTE documento, se filtra sin recargar (como
       siempre) y no se navega a ningún lado. */
    if(!catAuto.sinVista){
      e.preventDefault();
      catAuto.setFrom({ q: (f.ancho&&f.perfil) ? f.ancho+'/'+f.perfil : '', rin: f.rin, uso: f.cat || undefined });
      if(window.AVANTE_showCat) window.AVANTE_showCat('auto', true);
      return;
    }
    /* Si no está, dejamos que el <a> navegue con el href ya sincronizado. Para un
       <button> (el buscador de moto es así) sí hay que empujar la navegación a mano. */
    if(btn.tagName !== 'A'){ e.preventDefault(); location.href = '/pages/auto' + qsFiltros(f); }
  });
});
bloque('selects-moto', function(){
  var elR = $id('m-rin'), elM = $id('m-marca'), elMM = $id('m-motomarca'), elCC = $id('m-cc');
  if(!elR || !elM) return;                      // este documento no trae la portada
  var rines = Object.keys(MOTO.reduce(function(m,p){ if(p.r) m[p.r]=1; return m; },{})).map(Number).sort(function(a,b){return a-b;});
  var marcas = Object.keys(MOTO.reduce(function(m,p){ if(p.b) m[p.b]=1; return m; },{})).sort();
  fillSelect(elR, rines, {placeholder:'Todos'});
  fillSelect(elM, marcas, {placeholder:'Todas'});
  /* Marca de moto y cilindrada salen de la ficha técnica real (campos mb/cc de cada llanta,
     ver build_theme_data.py + scratch/moto_fitment.py). Si un día no hay dato, el select
     simplemente se queda con "Todas" en vez de romperse. */
  if(elMM) fillSelect(elMM, catMoto.motoBrandOptions(), {placeholder:'Todas'});
  if(elCC) fillSelect(elCC, catMoto.ccOptions(), {placeholder:'Todas'});
});

/* ===== logos reales de marca (los que Avante nos dio) — el resto se ve como texto ===== */
var ASSET_BASE = (function(){
  var s = document.querySelector('script[src*="catalog-data.js"]');
  return s ? s.src.replace(/catalog-data\.js.*$/, '') : '';
})();
/* Shopify versiona cada asset con un "?v=..." en la URL para que el navegador no se quede con
   una copia vieja en caché cuando se sube una versión nueva del mismo archivo. Como estas
   imágenes de marca se arman a mano (no con el filtro de Liquid asset_url), se les pega ese
   mismo "?v=..." que ya trae catalog-data.js, para que cualquier logo que se vuelva a subir se
   vea actualizado de inmediato en vez de quedarse pegado con la versión anterior en el navegador
   de la gente. */
var ASSET_VERSION_QS = (function(){
  var s = document.querySelector('script[src*="catalog-data.js"]');
  if(!s) return '';
  var m = s.src.match(/\?.*$/);
  return m ? m[0] : '';
})();
var BRAND_LOGOS = {
  'MICHELIN':'brand-michelin.png','PIRELLI':'brand-pirelli.png','DUNLOP':'brand-dunlop.png',
  'CONTINENTAL':'brand-continental.png','GOODYEAR':'brand-goodyear.png','HANKOOK':'brand-hankook.png',
  'BFGOODRICH':'brand-bfgoodrich.png','TVS EUROGRIP':'brand-eurogrip.png','PRAXIS':'brand-praxis.png',
  'SHINKO':'brand-shinko.png','TIMSUN':'brand-timsun.png','TORNEL':'brand-tornel.png',
  'YOKOHAMA':'brand-yokohama.png','SAYTO':'brand-sayto.png',
  'NEXEN':'brand-nexen.png','LAUFEN':'brand-laufen.png','BRIDGESTONE':'brand-bridgestone.png',
  'COOPER':'brand-cooper.png','JK TYRE':'brand-jktyre.png','KENDA':'brand-kenda.png',
  'KUMHO':'brand-kumho.png','ROYAL BLACK':'brand-royalblack.png'
};

/* ===== chips de marca en el home (moto + auto/camioneta juntos, top por existencia real) ===== */
bloque('chips-marca', function(){
  var counts = {}, inMoto = {}, inAuto = {};
  MOTO.forEach(function(p){ if(!p.b) return; counts[p.b]=(counts[p.b]||0)+1; inMoto[p.b]=true; });
  AUTO.forEach(function(p){ if(!p.b) return; counts[p.b]=(counts[p.b]||0)+1; inAuto[p.b]=true; });
  var top = Object.keys(counts).sort(function(a,b){ return counts[b]-counts[a]; }).slice(0,20);
  var el = $id('homeBrands');
  if(!el) return;
  el.innerHTML = top.map(function(b){
    var logo = BRAND_LOGOS[b.toUpperCase()];
    var inner = logo
      ? '<img src="'+ASSET_BASE+logo+ASSET_VERSION_QS+'" alt="'+esc(b)+'" loading="lazy">'
      : '<span class="txt">'+esc(b)+'</span>';
    return '<button class="brandchip'+(logo?' haslogo':'')+'" data-brand="'+esc(b)+'">'+inner+'<small>'+counts[b]+' modelos</small></button>';
  }).join('');
  el.addEventListener('click', function(e){
    var c = e.target.closest('[data-brand]');
    if(!c) return;
    var b = c.dataset.brand;
    var seg = inAuto[b] ? 'auto' : 'moto';
    var cat = seg === 'auto' ? catAuto : catMoto;
    if(!cat.sinVista){
      cat.setBrand(b);
      go(seg);
      if(window.AVANTE_showCat) window.AVANTE_showCat(seg, true);
      toast('Filtrando '+b);
      return;
    }
    location.href = '/pages/'+seg+qsFiltros({marca:b});
  });
});

/* top del home */
bloque('home-top', function(){
  var cont = $id('homeTop');
  if(!cont) return;
  var top = MOTO.slice().sort(function(a,b){ return b.st-a.st; }).slice(0,6);
  cont.innerHTML = top.map(function(p,i){
    var low = p.st<=2;
    return '<article class="card" style="animation-delay:'+(i*40)+'ms"><div class="shot'+(fotoDe(p)?' hasfoto':'')+'">'
      + '<span class="badge hot">'+p.st+' en piso</span>'
      + shotHTML(p, p.b+' '+p.n+' '+p.s, 400, '(max-width:600px) 45vw, (max-width:1100px) 30vw, 260px', i*31)
      + '</div>'
      + '<div class="body"><span class="brand">'+esc(p.b)+' · Moto</span>'
      + '<span class="name">'+esc(p.n)+'</span><span class="size">'+esc(p.s)+'</span>'
      + '<span class="stock'+(low?' low':'')+'"><i></i>'+(low?'Quedan '+p.st:'En existencia')+'</span>'
      + '<span class="price"><b>'+mx.format(p.p)+'</b><em class="unit">precio por 1 pieza</em></span>'
      + '<button class="add" data-add="'+p.id+'">Agregar</button></div></article>';
  }).join('');
});

/* buscador de moto del home */
bloque('buscador-moto', function(){
  var btn = $id('motoFind');
  if(!btn) return;
  btn.addEventListener('click', function(ev){
    var v = function(id){ var e = $id(id); return e ? e.value : ''; };
    var f = {rin: v('m-rin'), marca: v('m-marca'), motomarca: v('m-motomarca'), cc: v('m-cc')};
    if(!catMoto.sinVista){
      if(ev && ev.preventDefault) ev.preventDefault();
      catMoto.setFrom(f);
      go('moto');
      if(window.AVANTE_showCat) window.AVANTE_showCat('moto', true);
      return;
    }
    if(ev && ev.preventDefault) ev.preventDefault();
    location.href = '/pages/moto' + qsFiltros(f);
  });
});

/* ===== BUSCADOR GLOBAL (la lupa del header) ================================
   POR QUÉ EXISTE: el buscador del inicio está pensado para quien NO sabe su
   medida — tres selects que lo llevan de la mano. Pero el cliente que ya trae la
   medida en la cabeza (o la marca, o su moto) no tiene por qué pasar por ahí: en
   una llantera ese es el cliente más rápido de cerrar y el que peor tratábamos.

   Vive en el header, junto al carrito, así que funciona desde CUALQUIER ruta —
   igual que el carrito, el panel se renderiza fuera de las cinco vistas.

   QUÉ ACEPTA: medida en cualquier forma que la gente la escriba (205/55R16,
   205 55 16, 2055516, P205/55R16, 120/70-17), marca de llanta, modelo, marca de
   moto y cilindrada. Las sugerencias salen del catálogo REAL, así que es imposible
   que alguien busque algo y aterrice en una lista vacía: sólo se ofrece lo que hay.

   AL ELEGIR navega con los filtros en la URL (/pages/auto?q=205/55R16), que es el
   mismo mecanismo que usa el buscador del inicio desde que las vistas están
   partidas — ver vistas-partidas-por-url.md. */
bloque('buscador-global', function(){
  var btn   = $id('searchBtn'),  panel = $id('searchPanel'), scrim = $id('searchScrim'),
      input = $id('searchInput'), res   = $id('searchRes'),  hint  = $id('searchHint'),
      cerrarBtn = $id('searchClose');
  if(!btn || !panel || !input || !res) return;

  function norm(t){
    var x = (t == null ? '' : String(t)).toLowerCase();
    return x.normalize ? x.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : x;
  }
  /* Sólo los dígitos. Es lo que hace que "205 55 16", "205/55R16" y "2055516"
     sean la misma búsqueda: la gente escribe la medida de mil formas. */
  function digs(t){ return (t==null?'':String(t)).replace(/\D/g,''); }

  /* ---------- índice, construido una sola vez desde el catálogo real ---------- */
  var IDX = [];
  /* `kd` (sólo dígitos) se calcula SÓLO para medidas. Si se calculara para todo,
     un modelo como "PROXES R888R 80V" daría dígitos 88880 y saldría como resultado
     cuando alguien escribe su medida. */
  function push(o){ o.k = norm(o.txt); o.kd = o.tipo === 'medida' ? digs(o.txt) : ''; IDX.push(o); }

  function contar(arr, campo){
    var m = {};
    arr.forEach(function(p){
      var v = p[campo];
      if(Array.isArray(v)) v.forEach(function(x){ if(x) m[x]=(m[x]||0)+1; });
      else if(v) m[v]=(m[v]||0)+1;
    });
    return m;
  }
  function agregarGrupo(arr, campo, tipo, seg, param, orden){
    var m = contar(arr, campo);
    Object.keys(m).forEach(function(v){
      push({tipo:tipo, txt:v, n:m[v], seg:seg, param:param, orden:orden});
    });
  }

  /* Las medidas de auto vienen escritas de dos formas en el catálogo del proveedor:
     "205/55R16" y "P205/55R16" son la misma llanta (la P sólo dice "pasajero"). Son 35
     medidas con doble escritura, 237 SKUs. Si no se juntan, el cliente elige una de las
     dos sugerencias y NO VE la mitad del inventario de su medida.

     Se agrupan por el número, quitando el prefijo P **y también LT**, porque el buscador
     filtra por texto: buscar "215/65R15" devuelve igual las P que las LT. Así el número
     que se muestra al lado de la sugerencia es EXACTAMENTE lo que va a encontrar — nunca
     promete de más. Cuando el grupo mezcla pasajero y LT se avisa en el subtítulo, porque
     una LT es llanta reforzada de camioneta y no es lo mismo. */
  (function(){
    var g = {};
    AUTO.forEach(function(p){
      if(!p.s) return;
      var core = p.s.replace(/^(P|LT|ST)(?=\d)/i, '');
      var e = g[core] || (g[core] = {n:0, lt:false, pas:false});
      e.n++;
      if(/^LT/i.test(p.s)) e.lt = true; else e.pas = true;
    });
    Object.keys(g).forEach(function(core){
      var e = g[core];
      push({tipo:'medida', txt:core, n:e.n, seg:'auto', param:'q', orden:0,
            nota: (e.lt && e.pas) ? 'pasajero y LT (reforzada)' : (e.lt ? 'LT · camioneta reforzada' : '')});
    });
  })();
  agregarGrupo(MOTO, 's',  'medida', 'moto', 'q',         0);
  agregarGrupo(AUTO, 'b',  'marca',  'auto', 'marca',     1);
  agregarGrupo(MOTO, 'b',  'marca',  'moto', 'marca',     1);
  agregarGrupo(MOTO, 'mb', 'moto',   'moto', 'motomarca', 2);
  agregarGrupo(MOTO, 'cc', 'cc',     'moto', 'cc',        3);
  agregarGrupo(AUTO, 'u',  'uso',    'auto', 'cat',       4);
  agregarGrupo(MOTO, 'u',  'uso',    'moto', 'q',         4);
  /* modelos: marca + modelo, para quien busca "Rosso" o "Wrangler" */
  (function(){
    var m = {};
    [[AUTO,'auto'],[MOTO,'moto']].forEach(function(par){
      par[0].forEach(function(p){
        if(!p.n) return;
        var etiqueta = ((p.b ? p.b+' ' : '') + p.n).replace(/\s+/g,' ').trim();
        var k = par[1]+'|'+etiqueta;
        m[k] = (m[k]||0)+1;
      });
    });
    Object.keys(m).forEach(function(k){
      var seg = k.split('|')[0], etiqueta = k.slice(seg.length+1);
      push({tipo:'modelo', txt:etiqueta, n:m[k], seg:seg, param:'q', orden:5});
    });
  })();

  var ETIQUETA = {medida:'Medida', marca:'Marca', moto:'Tu moto', cc:'Cilindrada', uso:'Tipo', modelo:'Modelo'};
  var ICONO = {
    medida:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.4"/></svg>',
    marca :'<svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h10"/></svg>',
    moto  :'<svg viewBox="0 0 24 24"><circle cx="5.5" cy="17" r="3.2"/><circle cx="18.5" cy="17" r="3.2"/><path d="M5.5 17h5l4-7h4"/></svg>',
    cc    :'<svg viewBox="0 0 24 24"><path d="M12 3v6M7 21h10a3 3 0 003-3v-5H4v5a3 3 0 003 3z"/></svg>',
    uso   :'<svg viewBox="0 0 24 24"><path d="M3 12h4l3-7 4 14 3-7h4"/></svg>',
    modelo:'<svg viewBox="0 0 24 24"><path d="M4 6h16v12H4z"/><path d="M4 10h16"/></svg>'
  };
  function segTexto(seg){ return seg==='moto' ? 'moto' : 'auto y camioneta'; }

  function destino(e){
    var v = {};
    v[e.param] = e.txt;
    return '/pages/' + e.seg + qsFiltros(v);
  }

  /* ---------- puntuación ---------- */
  function puntuar(e, qn, qd){
    var pts = 0;
    if(qd && e.kd){
      if(e.kd === qd) pts = 150;
      else if(e.kd.indexOf(qd) === 0) pts = 120;
      else if(qd.length >= 3 && e.kd.indexOf(qd) > 0) pts = 55;
    }
    if(!pts && qn){
      var i = e.k.indexOf(qn);
      if(i === 0) pts = 100;
      else if(i > 0) pts = 45;
    }
    if(!pts) return 0;
    pts -= (e.orden || 0) * 2;                       // medidas y marcas primero
    pts += Math.min(12, Math.log(1 + e.n) * 3);      // lo que más hay, más arriba
    return pts;
  }

  function resaltar(txt, qn, qd){
    var t = esc(txt);
    if(qn){
      var i = norm(txt).indexOf(qn);
      if(i >= 0) return esc(txt.slice(0,i)) + '<mark>' + esc(txt.slice(i,i+qn.length)) + '</mark>' + esc(txt.slice(i+qn.length));
    }
    if(qd && digs(txt).indexOf(qd) === 0) return '<mark>' + t + '</mark>';
    return t;
  }

  function fila(e, qn, qd){
    return '<a class="sugg" role="option" href="' + esc(destino(e)) + '" data-seg="' + esc(e.seg)
      + '" data-param="' + esc(e.param) + '" data-val="' + esc(e.txt) + '">'
      + '<span class="sico">' + ICONO[e.tipo] + '</span>'
      + '<span class="stxt"><span class="sname">' + resaltar(e.txt, qn, qd) + '</span>'
      + '<span class="ssub">' + ETIQUETA[e.tipo] + ' · ' + segTexto(e.seg)
      + (e.nota ? ' · ' + esc(e.nota) : '') + '</span></span>'
      + '<span class="sn">' + e.n + '</span></a>';
  }

  /* ---------- sugerencias de arranque (panel recién abierto) ---------- */
  function arranque(){
    var top = IDX.filter(function(e){ return e.tipo === 'medida'; })
                 .sort(function(a,b){ return b.n - a.n; });
    var auto = top.filter(function(e){ return e.seg==='auto'; }).slice(0,5);
    var moto = top.filter(function(e){ return e.seg==='moto'; }).slice(0,3);
    res.innerHTML = '<div class="searchgrp">Las medidas que más nos piden</div>'
      + auto.concat(moto).map(function(e){ return fila(e, '', ''); }).join('');
    marcar(-1);
  }

  /* ---------- render ---------- */
  var actual = [];
  function pintar(){
    var q = input.value.trim();
    input.setAttribute('aria-expanded', q ? 'true' : 'false');
    if(!q){ actual = []; arranque(); return; }
    var qn = norm(q), qd = digs(q);
    var hits = [];
    for(var i=0;i<IDX.length;i++){
      var pts = puntuar(IDX[i], qn, qd);
      if(pts > 0) hits.push([pts, IDX[i]]);
    }
    hits.sort(function(a,b){ return b[0]-a[0]; });
    actual = hits.slice(0,12).map(function(h){ return h[1]; });
    if(!actual.length){
      res.innerHTML = '<div class="searchvacio">No encontramos <b>' + esc(q) + '</b> en el catálogo.<br>'
        + 'Puede ser que se escriba distinto, o que la tengamos que pedir — las conseguimos.'
        + '<br><a class="btn" target="_blank" rel="noopener noreferrer" href="'
        + esc(waLink('Hola Avante, busco ' + q + ' y no la encontré en la página. ¿Me ayudan?'))
        + '">Preguntar por WhatsApp</a></div>';
      return;
    }
    res.innerHTML = actual.map(function(e){ return fila(e, qn, qd); }).join('');
    marcar(-1);
  }

  /* ---------- teclado ---------- */
  var sel = -1;
  function opciones(){ return res.querySelectorAll('.sugg'); }
  function marcar(i){
    var els = opciones();
    sel = i;
    for(var k=0;k<els.length;k++) els[k].classList.toggle('on', k===i);
    if(i>=0 && els[i] && els[i].scrollIntoView) els[i].scrollIntoView({block:'nearest'});
  }

  /* Abrir y cerrar tienen que ser IDEMPOTENTES y no pisarse entre sí.
     En celular un toque puede generar dos eventos de clic (el táctil y el de ratón
     sintético). Con la versión ingenua eso dejaba el panel en un estado imposible:
     con la clase .on puesta pero hidden=true — o sea, invisible y sin forma de
     escribir. Se detectó emulando un dispositivo táctil de verdad, no se veía en
     escritorio. Por eso ahora manda una bandera (`abierto`) y se cancela el
     temporizador de cierre pendiente antes de abrir. */
  var abierto = false, tCerrar = null;

  function abrir(){
    if(abierto) return;
    abierto = true;
    clearTimeout(tCerrar);
    panel.hidden = false;
    void panel.offsetHeight;            // fuerza reflow para que la transición corra
    panel.classList.add('on');
    if(scrim) scrim.classList.add('on');
    btn.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
    pintar();
    setTimeout(function(){ input.focus(); input.select(); }, 60);
  }
  function cerrar(){
    if(!abierto) return;
    abierto = false;
    panel.classList.remove('on');
    if(scrim) scrim.classList.remove('on');
    btn.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    clearTimeout(tCerrar);
    tCerrar = setTimeout(function(){ if(!abierto) panel.hidden = true; }, 260);
  }

  function irA(el){
    if(!el) return;
    META.track('Search', {
      search_string: input.value.trim() || el.dataset.val,
      content_category: el.dataset.seg === 'moto' ? 'Moto' : 'Auto y camioneta'
    });
    var seg = el.dataset.seg, cat = seg === 'moto' ? catMoto : catAuto;
    /* Si el catálogo de ese segmento ya está en este documento, se filtra sin
       recargar; si no, el <a> navega solo con los filtros en la URL. */
    if(cat && !cat.sinVista){
      var o = {};
      o[el.dataset.param === 'q' ? 'q'
        : el.dataset.param === 'cat' ? 'uso'
        : el.dataset.param] = el.dataset.val;
      cat.setFrom(o);
      if(window.AVANTE_showCat) window.AVANTE_showCat(seg, true);
      /* La dirección tiene que contar lo mismo que la pantalla: si filtramos sin
         recargar y dejamos la URL vieja, el cliente comparte un enlace que lleva a
         otra búsqueda. */
      try {
        var v = {}; v[el.dataset.param] = el.dataset.val;
        history.replaceState({v:seg}, '', '/pages/' + seg + qsFiltros(v));
      } catch(err){}
      cerrar();
      return false;      // no navegar
    }
    return true;         // dejar que el enlace haga su trabajo
  }

  btn.addEventListener('click', function(e){ e.preventDefault(); abierto ? cerrar() : abrir(); });
  if(cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
  if(scrim) scrim.addEventListener('click', cerrar);

  var tmr;
  input.addEventListener('input', function(){ clearTimeout(tmr); tmr = setTimeout(pintar, 90); });

  input.addEventListener('keydown', function(e){
    var els = opciones();
    if(e.key === 'ArrowDown'){ e.preventDefault(); marcar(Math.min(sel+1, els.length-1)); }
    else if(e.key === 'ArrowUp'){ e.preventDefault(); marcar(Math.max(sel-1, -1)); }
    else if(e.key === 'Enter'){
      var el = sel >= 0 ? els[sel] : els[0];      // Enter sin elegir = la mejor sugerencia
      if(el){ e.preventDefault(); if(irA(el)) location.href = el.getAttribute('href'); }
    }
    else if(e.key === 'Escape'){ cerrar(); }
  });

  res.addEventListener('click', function(e){
    var el = e.target.closest('.sugg');
    if(!el) return;
    if(!irA(el)) e.preventDefault();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && abierto) cerrar();
    /* "/" abre el buscador, como en cualquier app que se respete — pero nunca
       mientras se escribe en otro campo. */
    if(e.key === '/' && !abierto){
      var a = document.activeElement, t = a && a.tagName;
      if(t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT' || (a && a.isContentEditable)) return;
      e.preventDefault(); abrir();
    }
  });

  if(hint) hint.setAttribute('data-n', IDX.length);
});

/* ===== carrito real de Shopify (/cart/add.js, /cart/change.js, /cart/clear.js) =====
   Ya NO es un carrito de mentiritas en memoria: cada "Agregar" pega de verdad al carrito
   de Shopify con el variant_id real del producto (viene de sku_to_variant.json vía
   build_theme_data.py). "Pagar en línea" manda a /checkout, el checkout real de Shopify.
   Falta: activar un método de pago en el admin de Shopify (Mercado Pago, Conekta, manual...)
   para que ese checkout pueda cobrar — sin eso, el carrito junta productos pero no cobra. */
var drawer = document.getElementById('drawer'), scrim = document.getElementById('scrim');
/* 9 sep 2026: al abrir el panel releemos el carrito real, para que quien vuelva del
   checkout o de otra pestaña no se quede viendo un estado viejo. */
function openCart(o){ drawer.classList.toggle('on', o); scrim.classList.toggle('on', o); if(o) fetchCart(); }
document.getElementById('cartBtn').addEventListener('click', function(){ openCart(true); });
document.getElementById('closeCart').addEventListener('click', function(){ openCart(false); });
scrim.addEventListener('click', function(){ openCart(false); });
document.addEventListener('keydown', function(e){ if(e.key==='Escape') openCart(false); });
document.getElementById('clearCart').addEventListener('click', function(){
  /* 9 sep 2026: validamos r.ok. Si vaciar falla, la respuesta de error NO se pinta
     como si fuera el carrito; el .catch deja la interfaz como estaba. */
  fetch('/cart/clear.js', {method:'POST', headers:{'Content-Type':'application/json'}})
    .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('clear '+r.status)); })
    .then(renderCartFromShopify)
    .catch(function(){});
});

function productMetaByVariant(vid){
  var all = MOTO.concat(AUTO);
  for(var i=0;i<all.length;i++){ if(all[i].vid===vid) return all[i]; }
  return null;
}

/* Ultimo recurso del boton Agregar: llevar la venta a WhatsApp en vez de perderla.
   Se deja puesto para siempre, no solo mientras los productos esten sin publicar: cualquier
   dia una variante se agota o se borra y el cliente tiene que seguir llegando con nosotros. */
function ventaPorWhatsApp(p, motivo){
  toast('Esa medida se aparta por WhatsApp — te abro el chat');
  var t = 'Hola, quiero esta llanta que vi en la pagina:\n'
        + p.b + ' ' + p.n + '\n'
        + 'Medida: ' + p.s + '\n'
        + 'Precio: ' + mx.format(p.p)
        + (p.sk ? '\nClave: ' + p.sk : '');
  META.track('Lead', Object.assign(META.deProducto(p), {content_category: 'rescate-carrito'}));
  setTimeout(function(){ window.open(waLink(t), '_blank', 'noopener'); }, 450);
}

/* Un solo listener para todos los enlaces de WhatsApp del sitio: ficha, carrito,
   promociones, tarjetas de oferta, cotizador y pie de página. Si mañana se agrega otro
   botón de WhatsApp, queda medido solo — no hay que acordarse de nada. */
document.addEventListener('click', function(e){
  var wa = e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"]');
  if(wa){
    var ctx = wa.closest('#pdModal') ? 'ficha'
            : wa.closest('#cartDrawer, .cart, #cartWa') ? 'carrito'
            : wa.closest('.promocard') ? 'promocion'
            : wa.closest('footer') ? 'pie'
            : 'sitio';
    var d = {content_category: ctx, currency: 'MXN'};
    try {
      var m = decodeURIComponent(wa.getAttribute('href')||'').match(/\$\s?([\d,]+)/);
      if(m) d.value = parseFloat(m[1].replace(/,/g,'')) || 0;
    } catch(err){}
    META.track('Lead', d);
  }
}, true);

document.addEventListener('click', function(e){
  var b = e.target.closest('[data-add]');
  if(!b) return;
  var p = catMoto.find(b.dataset.add) || catAuto.find(b.dataset.add);
  if(!p) return;
  if(!p.vid){ ventaPorWhatsApp(p, 'sin variante'); return; }
  b.disabled = true;
  fetch('/cart/add.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({items:[{id:p.vid, quantity:1}]})
  }).then(function(r){
    if(!r.ok) return r.json().then(function(err){ throw new Error(err.description||'add failed'); });
    return r.json();
  }).then(function(){
    b.textContent = 'Agregada ✓'; b.classList.add('done');
    setTimeout(function(){ b.textContent='Agregar'; b.classList.remove('done'); b.disabled=false; }, 1300);
    toast(p.b+' '+p.n+' agregada');
    fetchCart();
  }).catch(function(err){
    b.disabled = false;
    /* Red de seguridad. Si Shopify no puede agregar la variante -- porque no esta publicada
       en el canal Tienda en linea, porque se agoto o porque se borro -- la venta NO se muere
       en un toast que nadie lee: se manda al cliente a WhatsApp con la llanta ya escrita. */
    ventaPorWhatsApp(p, 'no se pudo agregar');
  });
});

var delivery = {mode:'tienda', cp:'', rates:null, estado:'', cargando:false};
/* FREE_SHIP = umbral a partir del cual el envío sale gratis. En 0 = NO hay envío gratis.
   27-ago-2026 (Amaury): se quitó el envío gratis y se pusieron tarifas reales en Shopify —
   $150 en CDMX (1-2 días) y $450 al resto de la República (3-5 días). El carrito ya no
   promete nada: pregunta la tarifa real a Shopify con el CP y muestra lo que Shopify diga.
   Si algún día se vuelve a ofrecer envío gratis, se sube el umbral aquí Y se crea en Shopify
   la condición "gratis desde $X" — si sólo se cambia aquí, el sitio miente contra el checkout. */
var FREE_SHIP = 0;

/* ===== INTERRUPTOR DEL COTIZADOR DE ENVÍO =====
   false = el carrito NO muestra precios de envío. Enseña la opción "Envío a domicilio",
           pide el código postal para saber a dónde va, y dice que el costo se cotiza por
           WhatsApp. Es lo que Amaury pidió el 27 de agosto: que el cliente pague las
           llantas en línea y el envío se acuerde aparte.
   true  = vuelve a consultar las tarifas reales a Shopify y las muestra en el carrito.

   TODO el cotizador sigue aquí, funcionando y probado. Para reactivarlo cuando exista la
   cuenta de paquetería, se cambia esta sola palabra a true y se sube el archivo. */
var COTIZA_ENVIO = true;


/* Los primeros dos dígitos del código postal mexicano determinan el estado. Shopify
   necesita el estado además del CP para poder cotizar: con el CP solo, la API devuelve
   una lista vacía y parece que "no hay envío a esa zona". */
/* [desde, hasta, nombre-para-la-API, nombre-para-mostrar]. Van sin acento para la API
   porque así los espera Shopify, y con acento para el cliente. */
var CP_ESTADO = [
  [1,16,'Ciudad de Mexico','Ciudad de México'], [20,20,'Aguascalientes','Aguascalientes'],
  [21,22,'Baja California','Baja California'], [23,23,'Baja California Sur','Baja California Sur'],
  [24,24,'Campeche','Campeche'], [25,27,'Coahuila','Coahuila'], [28,28,'Colima','Colima'],
  [29,30,'Chiapas','Chiapas'], [31,33,'Chihuahua','Chihuahua'], [34,35,'Durango','Durango'],
  [36,38,'Guanajuato','Guanajuato'], [39,41,'Guerrero','Guerrero'], [42,43,'Hidalgo','Hidalgo'],
  [44,49,'Jalisco','Jalisco'], [50,57,'Mexico','Estado de México'], [58,61,'Michoacan','Michoacán'],
  [62,62,'Morelos','Morelos'], [63,63,'Nayarit','Nayarit'], [64,67,'Nuevo Leon','Nuevo León'],
  [68,71,'Oaxaca','Oaxaca'], [72,75,'Puebla','Puebla'], [76,76,'Queretaro','Querétaro'],
  [77,77,'Quintana Roo','Quintana Roo'], [78,79,'San Luis Potosi','San Luis Potosí'],
  [80,82,'Sinaloa','Sinaloa'], [83,85,'Sonora','Sonora'], [86,86,'Tabasco','Tabasco'],
  [87,89,'Tamaulipas','Tamaulipas'], [90,90,'Tlaxcala','Tlaxcala'], [91,96,'Veracruz','Veracruz'],
  [97,97,'Yucatan','Yucatán'], [98,99,'Zacatecas','Zacatecas']
];
function filaCP(cp){
  if(!cp || cp.length !== 5) return null;
  var n = +cp.slice(0,2);
  for(var i=0;i<CP_ESTADO.length;i++){
    if(n >= CP_ESTADO[i][0] && n <= CP_ESTADO[i][1]) return CP_ESTADO[i];
  }
  return null;
}
function estadoPorCP(cp){ var f = filaCP(cp); return f ? f[2] : ''; }
function estadoBonito(cp){ var f = filaCP(cp); return f ? f[3] : ''; }

/* Cotiza contra Shopify de verdad. Antes aquí había una tabla de precios escrita a mano
   ($180 zona metro / $290 foráneo) que NO coincidía con lo que la tienda cobra al pagar:
   el cliente veía un número en el carrito y otro en el checkout. Ahora se le pregunta a
   Shopify por las tarifas reales del carrito actual, que es la única fuente correcta. */
var cotizaTimer = null;
function cotizarEnvio(){
  if(!COTIZA_ENVIO){ pintarEnvio(); return; }
  if(delivery.mode !== 'envio') return;
  var cp = delivery.cp, estado = estadoPorCP(cp);
  if(!estado){ delivery.rates = null; delivery.cargando = false; pintarEnvio(); return; }
  delivery.estado = estadoBonito(cp);
  delivery.cargando = true;
  pintarEnvio();
  var q = '/cart/shipping_rates.json'
        + '?shipping_address[zip]=' + encodeURIComponent(cp)
        + '&shipping_address[country]=Mexico'
        + '&shipping_address[province]=' + encodeURIComponent(estado);
  fetch(q, {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error(r.status)); })
    .then(function(d){
      delivery.rates = (d && d.shipping_rates) ? d.shipping_rates : [];
      delivery.cargando = false;
      pintarEnvio();
    })
    .catch(function(){
      /* Si la consulta falla no inventamos un número: se dice la verdad, que el costo
         se calcula al pagar. Un estimado equivocado es peor que no dar estimado. */
      delivery.rates = null;
      delivery.cargando = false;
      pintarEnvio();
    });
}
function cotizarConEspera(){
  clearTimeout(cotizaTimer);
  cotizaTimer = setTimeout(cotizarEnvio, 450);
}

/* La tarifa más barata que devolvió Shopify, en pesos. null si todavía no sabemos. */
function envioMasBarato(){
  if(!delivery.rates || !delivery.rates.length) return null;
  var min = null;
  delivery.rates.forEach(function(r){
    var p = parseFloat(r.price);          // la API lo devuelve en pesos, no en centavos
    if(isNaN(p)) return;
    if(min === null || p < min) min = p;
  });
  return min;
}

document.querySelector('.delivery .opts').addEventListener('click', function(e){
  var b = e.target.closest('[data-del]'); if(!b) return;
  this.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
  b.classList.add('on');
  delivery.mode = b.dataset.del;
  document.getElementById('cpBox').hidden = delivery.mode!=='envio';
  fetchCart();
  if(delivery.mode === 'envio') cotizarEnvio();
});
document.getElementById('cpInput').addEventListener('input', function(){
  delivery.cp = this.value.replace(/\D/g,'').slice(0,5);
  this.value = delivery.cp;
  delivery.rates = null;
  cotizarConEspera();
  pintarEnvio();
});

var lastCart = {items:[], item_count:0, total_price:0};
function fetchCart(){
  /* 9 sep 2026: validamos r.ok y atrapamos el error. Si /cart.js falla, más vale dejar
     el carrito como está que pintar una respuesta de error como carrito vacío. */
  return fetch('/cart.js')
    .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('cart '+r.status)); })
    .then(renderCartFromShopify)
    .catch(function(){});
}

/* Pinta el renglón y la nota de envío a partir de lo que Shopify contestó.
   Regla: nunca inventar un número. Si no sabemos, se dice que se calcula al pagar. */
function pintarEnvio(sub, hayItems){
  var note = document.getElementById('shipNote');
  var celda = document.getElementById('cartShip');
  var fila  = document.getElementById('rowShip');
  if(!note || !celda) return;
  /* 9 sep 2026: mismo criterio que en renderCartFromShopify — la mercancía es
     items_subtotal_price, no total_price (que puede traer el flete adentro).
     Así las dos rutas de cálculo coinciden y el envío se suma una sola vez. */
  if(sub === undefined) sub = ((lastCart.items_subtotal_price != null ? lastCart.items_subtotal_price : lastCart.total_price) || 0) / 100;
  if(hayItems === undefined) hayItems = (lastCart.items||[]).length;

  if(fila) fila.querySelector('span').textContent = 'Envío';

  if(delivery.mode === 'tienda'){
    note.className = 'shipnote';
    note.textContent = 'Recoges en Canal de Miramontes 2543, Coyoacán. El costo de instalación depende del vehículo y la marca, se cotiza en sucursal.';
    return;
  }

  /* Cotizador apagado: la opción existe y se ve, pero no damos precio. */
  if(!COTIZA_ENVIO){
    celda.textContent = 'Por cotizar';
    note.className = 'shipnote';
    if(!hayItems){
      note.textContent = 'Hacemos envíos a toda la República. El costo se cotiza aparte por WhatsApp.';
    } else if(delivery.cp.length === 5 && estadoBonito(delivery.cp)){
      note.textContent = 'Envío a ' + estadoBonito(delivery.cp) + '. Pagas las llantas aquí y el costo del envío te lo cotizamos por WhatsApp antes de mandarlo — no viene incluido en este total.';
    } else {
      note.textContent = 'Pagas las llantas aquí y el envío te lo cotizamos por WhatsApp antes de mandarlo — no viene incluido en este total. Escribe tu código postal para tenerlo a la mano.';
    }
    return;
  }
  if(!hayItems){
    celda.textContent = '—';
    note.className = 'shipnote';
    note.textContent = 'Agrega algo al carrito y pon tu código postal para ver el costo exacto del envío.';
    return;
  }
  if(delivery.cp.length !== 5){
    celda.textContent = '—';
    note.className = 'shipnote';
    note.textContent = 'Escribe tu código postal y te decimos el costo exacto del envío.'
      + (FREE_SHIP > 0 ? ' Gratis desde ' + mx.format(FREE_SHIP) + '.' : '');
    return;
  }
  if(!estadoPorCP(delivery.cp)){
    celda.textContent = '—';
    note.className = 'shipnote';
    note.textContent = 'Ese código postal no lo reconocemos. Revísalo, o escríbenos por WhatsApp y lo cotizamos a mano.';
    return;
  }
  if(delivery.cargando){
    celda.textContent = '…';
    note.className = 'shipnote';
    note.textContent = 'Consultando el costo de envío a ' + delivery.estado + '…';
    return;
  }
  if(delivery.rates === null){
    celda.textContent = 'Al pagar';
    note.className = 'shipnote';
    note.textContent = 'No pudimos consultar la tarifa en este momento. El costo exacto aparece en la pantalla de pago.';
    return;
  }
  if(!delivery.rates.length){
    celda.textContent = 'Al pagar';
    note.className = 'shipnote';
    note.textContent = 'No encontramos tarifa para ese código postal. Escríbenos por WhatsApp y lo resolvemos.';
    return;
  }
  var min = envioMasBarato();
  if(min === 0){
    celda.textContent = 'Gratis';
    note.className = 'shipnote free';
    note.textContent = '✓ Envío sin costo a ' + delivery.estado + '.'
      + (FREE_SHIP > 0 ? ' Tu pedido pasa de ' + mx.format(FREE_SHIP) + '.' : '');
    return;
  }
  celda.textContent = mx.format(min);
  var falta = FREE_SHIP > 0 ? FREE_SHIP - sub : 0;
  note.className = 'shipnote';
  if(falta > 0){
    note.textContent = 'Envío a ' + delivery.estado + ': ' + mx.format(min)
      + '. Te faltan ' + mx.format(falta) + ' para que salga gratis.';
  } else {
    note.textContent = 'Envío a ' + delivery.estado + ': ' + mx.format(min)
      + '. Es el costo del flete por paquetería; se suma al total al pagar.';
  }
  if(delivery.rates.length > 1){
    var otras = delivery.rates.slice().sort(function(a,b){ return parseFloat(a.price)-parseFloat(b.price); })
      .map(function(r){ return r.name + ' ' + (parseFloat(r.price)===0 ? 'gratis' : mx.format(parseFloat(r.price))); })
      .join(' · ');
    note.textContent += ' Opciones: ' + otras + '.';
  }
}

function renderCartFromShopify(shopifyCart){
  /* 9 sep 2026: una respuesta de error no es un carrito. Sin esta guarda, el 400 de
     /cart/change.js llegaba hasta aquí y se pintaba "Tu carrito está vacío" con total
     $0 aunque el carrito real tuviera productos. Aquí NO llamamos a fetchCart(): bucle. */
  if(!shopifyCart || !shopifyCart.items){ return; }
  lastCart = shopifyCart;
  var items = shopifyCart.items || [];
  document.getElementById('cartCount').textContent = shopifyCart.item_count || 0;
  var elItems = document.getElementById('cartItems');
  if(!items.length){
    elItems.innerHTML = '<div class="empty" style="margin:22px 0">Tu carrito está vacío.<br><br><a class="btn ghost sm" href="/pages/moto" data-go="moto">Ver llantas de moto</a></div>';
  } else {
    elItems.innerHTML = items.map(function(it){
      var meta = productMetaByVariant(it.variant_id);
      var seg = meta ? meta.seg : 'auto';
      return '<div class="litem"><div class="th">'
        + shotHTML(meta, it.product_title, 180, '56px')
        + '</div>'
        + '<div><div class="n">'+esc(it.product_title)+'</div><div class="s">'+esc(meta?meta.s:'')+'</div>'
        + '<div class="qty"><button data-q="-" data-vid="'+it.variant_id+'">−</button><span>'+it.quantity+'</span><button data-q="+" data-vid="'+it.variant_id+'">+</button></div></div>'
        + '<div class="p">'+mx.format(it.line_price/100)+'</div></div>';
    }).join('');
  }
  /* 9 sep 2026: el subtotal de PRODUCTOS es items_subtotal_price, no total_price.
     Cuando el carrito ya trae tarifa de envío (cliente que fue al checkout y volvió),
     la respuesta de /cart/change.js mete el flete dentro de total_price y el panel
     mostraba mercancía inflada — y el envío se volvía a sumar aparte en su renglón.
     Medido: líneas por $1,600 y total_price $1,750. */
  var sub = ((shopifyCart.items_subtotal_price != null ? shopifyCart.items_subtotal_price : shopifyCart.total_price) || 0) / 100;
  var pickup = delivery.mode==='tienda';
  /* La instalación (montaje + balanceo) NO es un precio único: depende del tipo de vehículo
     (moto / auto / camioneta), del rin y de la marca. Por eso ya no mostramos un estimado
     numérico aquí — se cotiza en sucursal o por WhatsApp. Cuando exista el tabulador real
     de servicios, este texto se cambia por el cálculo. */
  document.getElementById('cartSub').textContent = mx.format(sub);
  document.getElementById('cartInst').textContent = 'Según vehículo y marca';
  document.getElementById('rowInst').hidden = !pickup;
  document.getElementById('rowShip').hidden = pickup;
  var apn = document.getElementById('apartadoNote');
  if(apn) apn.hidden = !items.length;
  document.getElementById('cartTotal').textContent = mx.format(sub);
  pintarEnvio(sub, items.length);
  /* El carrito cambió, así que la cotización anterior ya no vale: el precio del envío
     depende del peso total y del subtotal (por el umbral de envío gratis). */
  if(delivery.mode === 'envio' && delivery.cp.length === 5) cotizarConEspera();

  var lines = items.map(function(it){ return '• '+it.quantity+'x '+it.product_title+' — '+mx.format(it.line_price/100); }).join('\n');
  var msg = 'Hola Avante, quiero cerrar este pedido:\n\n' + (lines||'(carrito vacío)') + '\n\n'
    + (pickup
        ? 'Entrega: recojo en sucursal\nInstalación: la cotizo con ustedes (depende del vehículo y la marca)'
        : 'Entrega: envío a domicilio' + (delivery.cp ? ' (CP '+delivery.cp+')' : '')
          + (COTIZA_ENVIO ? '' : '\n¿Me cotizan el envío, por favor? Entiendo que el costo va aparte.'))
    + '\nSubtotal productos: '+mx.format(sub)
    /* El apartado no es igual en los dos segmentos: en moto son $200 por transferencia y en
       auto/camioneta es el 50% de anticipo (fuente: Respuestas_de_siempre del negocio). El
       mensaje se adapta a lo que la persona trae en el carrito para no prometer de menos. */
    + '\n\n' + (items.some(function(it){ var m = productMetaByVariant(it.variant_id); return m && m.seg === 'auto'; })
        ? 'Entiendo que para apartar llantas de auto se pide el 50% de anticipo. ¿Me pasan los datos?'
        : 'Entiendo que para apartar necesito dar el anticipo de $200 MXN. ¿Me pasan los datos para el apartado?');
  document.getElementById('cartWa').href = waLink(msg);
}
document.getElementById('cartItems').addEventListener('click', function(e){
  var b = e.target.closest('[data-q]');
  if(!b) return;
  var vid = +b.dataset.vid;
  var line = lastCart.items.filter(function(it){ return it.variant_id===vid; })[0];
  var newQty = (line ? line.quantity : 0) + (b.dataset.q==='+' ? 1 : -1);
  /* 9 sep 2026: el id va como TEXTO. Con el id numérico Shopify contesta 400
     (expected Integer to be a (\A\d+\z)|(\A\d+:[a-f0-9]{32}\z): id) y esa respuesta
     de error terminaba pintándose como carrito vacío. Si no viene ok, no pintamos:
     avisamos y releemos el carrito real. */
  fetch('/cart/change.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id:String(vid), quantity: Math.max(0,newQty)})
  }).then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('change '+r.status)); })
    .then(renderCartFromShopify)
    .catch(function(){ if(typeof toast==='function') toast('No se pudo actualizar la cantidad'); fetchCart(); });
});
fetchCart();

/* ===== cotizador de servicios ===== */
/* ===== PRECIOS DE SERVICIO — corregidos el 31 ago 2026 =====================
   FUENTE ÚNICA: la bóveda de Avante, pestaña `Servicios_Auto` (32 filas, captura manual)
   más las correcciones de las entrevistas a Ana (26-ago) y a Jorge (27-ago). Amaury
   confirmó el 31-ago que la bóveda manda sobre lo que tenía el sitio.

   Lo que estaba mal aquí, y no era poca cosa:
     · Se cobraba montaje ($120) y balanceo ($100) que van INCLUIDOS con la compra.
     · Rotación $180 cuando son $350.  Nitrógeno $60 cuando son $100.
     · Reparación de ponchadura $90 cuando es DESDE $350.
     · "Alineación 3D $450" como precio cerrado, cuando depende del vehículo
       ($350 sedán chico · $450 sedán grande o mini SUV · $600 SUV) y la trasera
       es "desde $900".
   O sea: se cotizaba de menos en unos servicios y de más en otros. Cada cotización
   que salió de aquí estaba mal.

   REGLA QUE IMPONE LA BÓVEDA, y por eso este cotizador ahora dice "desde":
   varios precios son un PISO, no un cerrado. La nota de la bóveda es literal:
   «Decir "$900" sin el "desde" convierte un piso en un precio cerrado». El negocio
   cotiza por teléfono con un rango y cierra el precio en piso.

   Si cambias un precio aquí, cámbialo también en el JSON-LD de la vista `servicios`
   (sections/avante-app.liquid). Declarar un precio que la página no muestra es
   penalización en buscadores, y contradecirse es peor que no decir nada. */
var SERVICES = [
  {k:'montaje',   t:'Montaje y balanceo',        d:'incluido con la compra de tus llantas aquí', price:0,   per:'llanta', gratis:true},
  {k:'externa',   t:'Montaje de llanta externa', d:'por llanta, si traes tu llanta',             price:150, per:'llanta'},
  {k:'balanceo',  t:'Balanceo de llanta suelta', d:'por llanta',                                 price:150, per:'llanta'},
  {k:'alineacion',t:'Alineación delantera',      d:'sedán chico $350 · sedán grande o mini SUV $450 · SUV $600', price:350, per:'servicio', desde:true, noMoto:true},
  {k:'rotacion',  t:'Rotación',                  d:'servicio completo',                          price:350, per:'servicio', noMoto:true},
  {k:'reparacion',t:'Reparación de ponchadura',  d:'por llanta · parche frío en sucursal',       price:350, per:'llanta', desde:true},
  {k:'nitrogeno', t:'Inflado con nitrógeno',     d:'por llanta',                                 price:100, per:'llanta'},
  {k:'rampa',     t:'Revisión en rampa',         d:'suspensión o alineación · se descuenta si haces el trabajo aquí', price:350, per:'servicio', noMoto:true}
];
var q = {veh:'auto', factor:1, svcs:['montaje','balanceo'], qty:4, day:null, hour:'10:00'};
var DAYS = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];
var HOURS = ['9:00','10:00','11:00','12:00','13:00','16:00','17:00'];

function renderServices(){
  if(!$id('qServices')) return;   // el cotizador no está en esta ruta

  document.getElementById('qServices').innerHTML = SERVICES.map(function(s){
    var off = q.veh==='moto' && s.noMoto;
    return '<button class="svcopt'+(q.svcs.indexOf(s.k)>=0?' on':'')+'" data-svc="'+s.k+'"'+(off?' disabled style="opacity:.4"':'')+'>'
      + '<span class="box"></span><span class="t"><b>'+s.t+'</b><span>'
      + (s.gratis ? 'Sin costo' : (s.desde ? 'desde ' : '') + mx.format(Math.round(s.price*q.factor)))
      + ' · '+s.d+'</span></span></button>';
  }).join('');
}
function renderDays(){
  if(!$id('qServices')) return;   // el cotizador no está en esta ruta

  var today = new Date();
  var h = '';
  for(var i=0;i<8;i++){
    var d = new Date(today.getTime() + i*86400000);
    var dow = d.getDay();
    var closed = dow===0;
    if(q.day===null && !closed){ q.day = d.toISOString().slice(0,10); }
    h += '<button class="day'+(q.day===d.toISOString().slice(0,10)?' on':'')+'" data-day="'+d.toISOString().slice(0,10)+'"'+(closed?' disabled':'')+'>'
       + '<b>'+d.getDate()+'</b><span>'+(closed?'cerrado':DAYS[dow])+'</span></button>';
  }
  document.getElementById('qDays').innerHTML = h;
  document.getElementById('qHours').innerHTML = HOURS.map(function(x){
    return '<button class="hour'+(q.hour===x?' on':'')+'" data-hour="'+x+'">'+x+'</button>';
  }).join('');
}
function quoteTotal(){
  /* `desde` marca los servicios cuyo precio es un PISO y no un cerrado. Si el usuario
     escoge alguno, el total entero pasa a ser "desde": sumar un piso con un cerrado y
     presentarlo como cerrado es prometer un precio que el taller no puede sostener. */
  var lines = [], total = 0, esDesde = false;
  SERVICES.forEach(function(s){
    if(q.svcs.indexOf(s.k)<0) return;
    if(q.veh==='moto' && s.noMoto) return;
    var unit = Math.round(s.price*q.factor);
    var amount = s.per==='llanta' ? unit*q.qty : unit;
    total += amount;
    if(s.desde) esDesde = true;
    lines.push({t:s.t + (s.per==='llanta' ? ' ×'+q.qty : ''), a:amount, gratis:s.gratis, desde:s.desde});
  });
  return {lines:lines, total:total, desde:esDesde};
}
function renderQuote(){
  if(!$id('qServices')) return;   // el cotizador no está en esta ruta

  var r = quoteTotal();
  document.getElementById('qLines').innerHTML = r.lines.length
    ? r.lines.map(function(l){ return '<div class="qline"><span>'+l.t+'</span><b>'
        + (l.gratis ? 'Sin costo' : (l.desde ? 'desde ' : '') + mx.format(l.a)) + '</b></div>'; }).join('')
    : '<div class="qline"><span>Elige al menos un servicio</span><b>—</b></div>';
  var dayTxt = '—';
  if(q.day){ var d = new Date(q.day+'T12:00:00'); dayTxt = DAYS[d.getDay()]+' '+d.getDate(); }
  document.getElementById('qMeta').innerHTML =
      '<span>Vehículo: '+q.veh+'</span><span>Llantas: '+q.qty+'</span><span>Cita: '+dayTxt+' '+(q.hour||'—')+'</span>';
  document.getElementById('qTotal').textContent = (r.desde ? 'desde ' : '') + mx.format(r.total);
  var mins = 0;
  SERVICES.forEach(function(s2){
    if(q.svcs.indexOf(s2.k)<0) return;
    if(q.veh==='moto' && s2.noMoto) return;
    /* Tiempos de la bóveda (entrevista a Ana, A-026): montaje 20 min por llanta,
       alineación 30-40 min, 4 llantas 1h-1h15, 4 llantas + alineación ~1h30. */
    mins += (s2.per==='llanta' ? (s2.k==='montaje'||s2.k==='externa'?20:s2.k==='balanceo'?10:s2.k==='reparacion'?15:3) * q.qty : (s2.k==='alineacion'?35:20));
  });
  document.getElementById('qTime').innerHTML = mins
    ? '<b>~'+mins+' min</b> en taller · te avisamos por WhatsApp cuando esté listo'
    : 'Elige servicios para estimar el tiempo';
  var msg = 'Hola Avante, quiero agendar servicio:\n\nVehículo: '+q.veh+'\nLlantas: '+q.qty
    + '\nServicios:\n' + r.lines.map(function(l){ return '• '+l.t+' — '+mx.format(l.a); }).join('\n')
    + '\nTotal estimado: '+mx.format(r.total)
    + '\nCita: '+dayTxt+' a las '+(q.hour||'por definir');
  document.getElementById('qWa').href = waLink(msg);
}
/* El cotizador de servicios vive dentro de la vista Servicios: en cualquier otra ruta
   sus elementos no existen. Con las vistas partidas, esto ANTES tiraba TypeError y se
   llevaba entre las patas todo lo que venía después en el archivo. */
bloque('cotizador-servicios', function(){
  if(!$id('qVehicle') || !$id('qServices')) return;
  document.getElementById('qVehicle').addEventListener('click', function(e){
    var b = e.target.closest('.opt'); if(!b) return;
    this.querySelectorAll('.opt').forEach(function(x){ x.classList.remove('on'); });
    b.classList.add('on');
    q.veh = b.dataset.v; q.factor = +b.dataset.f;
    if(q.veh==='moto'){ q.qty = 2; q.svcs = q.svcs.filter(function(k){ return ['alineacion','rotacion'].indexOf(k)<0; }); }
    else if(q.qty===2){ q.qty = 4; }
    document.getElementById('qQty').textContent = q.qty;
    renderServices(); renderQuote();
  });
  document.getElementById('qServices').addEventListener('click', function(e){
    var b = e.target.closest('.svcopt'); if(!b || b.disabled) return;
    var k = b.dataset.svc, ix = q.svcs.indexOf(k);
    if(ix<0) q.svcs.push(k); else q.svcs.splice(ix,1);
    b.classList.toggle('on');
    renderQuote();
  });
  document.getElementById('qPlus').addEventListener('click', function(){ if(q.qty<8){ q.qty++; document.getElementById('qQty').textContent=q.qty; renderQuote(); } });
  document.getElementById('qMinus').addEventListener('click', function(){ if(q.qty>1){ q.qty--; document.getElementById('qQty').textContent=q.qty; renderQuote(); } });
  document.getElementById('qDays').addEventListener('click', function(e){
    var b = e.target.closest('.day'); if(!b || b.disabled) return;
    q.day = b.dataset.day;
    this.querySelectorAll('.day').forEach(function(x){ x.classList.remove('on'); });
    b.classList.add('on'); renderQuote();
  });
  document.getElementById('qHours').addEventListener('click', function(e){
    var b = e.target.closest('.hour'); if(!b) return;
    q.hour = b.dataset.hour;
    this.querySelectorAll('.hour').forEach(function(x){ x.classList.remove('on'); });
    b.classList.add('on'); renderQuote();
  });
  renderServices(); renderDays(); renderQuote();
});

/* ===== toast ===== */
var toastEl = document.getElementById('toast'), toastT;
function toast(msg){
  toastEl.textContent = msg; toastEl.classList.add('on');
  clearTimeout(toastT); toastT = setTimeout(function(){ toastEl.classList.remove('on'); }, 2000);
}

/* ===== tema ===== */
document.getElementById('themeBtn').addEventListener('click', function(){
  var cur = document.documentElement.getAttribute('data-theme');
  var next = (cur === 'dark') ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  try { localStorage.setItem('avante-theme', next); } catch(e) {}
  drawTread(); drawMap();
});

/* ===== reveals ===== */
var io = null;
function observeReveals(){
  if(!('IntersectionObserver' in window)){ document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); return; }
  if(!io){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    },{rootMargin:'0px 0px -40px 0px'});
  }
  document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ io.observe(el); });
}
observeReveals();

/* ===== cifras reales del catálogo =====
   El contador animado del hero (1,710 modelos / 88 marcas / 24 h) se quitó a petición de
   Amaury. Se conserva esto porque el número de modelos de moto se sigue usando en el texto
   de ayuda del buscador de la portada de Moto, y ahí sí tiene que ser el real. */
(function(){
  document.querySelectorAll('[data-stat-text="modelos-moto"]').forEach(function(el){ el.textContent = MOTO.length; });
})();

/* ===== fondos canvas ===== */
function drawTread(){
  var tc = document.getElementById('treadCanvas'); if(!tc) return;
  var dpr = Math.min(window.devicePixelRatio||1,2), w = tc.clientWidth, h = tc.clientHeight;
  if(!w||!h) return;
  tc.width = w*dpr; tc.height = h*dpr;
  var g = tc.getContext('2d'); g.setTransform(dpr,0,0,dpr,0,0);
  g.fillStyle = '#0B0908'; g.fillRect(0,0,w,h);
  var cx = w*0.5, lanes = 7, spread = w*1.5;
  g.strokeStyle = 'rgba(245,241,234,0.055)';
  for(var i=0;i<=lanes;i++){
    var t = i/lanes; g.beginPath(); g.lineWidth = 1+t*0.6;
    g.moveTo(cx+(t-0.5)*w*0.34, 0); g.lineTo(cx+(t-0.5)*spread, h); g.stroke();
  }
  for(var r=0;r<26;r++){
    var p = r/26, y = Math.pow(p,2.1)*h, hh = Math.max(1.2, Math.pow(p,2.1)*h*0.055);
    var wide = w*0.34 + p*(spread - w*0.34);
    g.fillStyle = 'rgba(245,241,234,'+(0.018+p*0.05)+')'; g.fillRect(cx-wide/2, y, wide, hh);
    g.fillStyle = 'rgba(255,107,44,'+(p*0.03)+')'; g.fillRect(cx-wide/2, y+hh, wide, hh*0.35);
  }
}
function drawMap(){
  var mc = document.getElementById('mapCanvas'); if(!mc) return;
  var dpr = Math.min(window.devicePixelRatio||1,2), w = mc.clientWidth, h = mc.clientHeight;
  if(!w||!h) return;
  mc.width = w*dpr; mc.height = h*dpr;
  var g = mc.getContext('2d'); g.setTransform(dpr,0,0,dpr,0,0);
  var cs = getComputedStyle(document.documentElement);
  var ground = cs.getPropertyValue('--ground-2').trim()||'#eee';
  var line = cs.getPropertyValue('--line').trim()||'#ddd';
  var strong = cs.getPropertyValue('--line-strong').trim()||'#bbb';
  g.fillStyle = ground; g.fillRect(0,0,w,h);
  g.strokeStyle = line; g.lineWidth = 1;
  for(var x=-20;x<w+40;x+=34){ g.beginPath(); g.moveTo(x,0); g.lineTo(x+26,h); g.stroke(); }
  for(var y=0;y<h+20;y+=40){ g.beginPath(); g.moveTo(0,y); g.lineTo(w,y-14); g.stroke(); }
  g.strokeStyle = strong; g.lineWidth = 9;
  g.beginPath(); g.moveTo(w*0.28,-10); g.lineTo(w*0.70,h+10); g.stroke();
  g.strokeStyle = ground; g.lineWidth = 1.5; g.setLineDash([7,7]);
  g.beginPath(); g.moveTo(w*0.28,-10); g.lineTo(w*0.70,h+10); g.stroke();
  g.setLineDash([]);
}
function redraw(){ drawTread(); drawMap(); }
window.addEventListener('resize', redraw);
if(document.fonts && document.fonts.ready){ document.fonts.ready.then(redraw); }
redraw(); setTimeout(redraw,150);

/* ruta inicial (permite compartir /moto, /servicios, etc.) */
(function(){
  var r = routeFromPath();
  if(r!=='home') go(r, false);
  if(location.hash){
    var h = location.hash.replace('#','').toLowerCase();
    if(['auto','moto','servicios','sucursal','envios'].indexOf(h)>=0) go(h==='envios'?'sucursal':h, false);
  }
})();

/* ===== FICHA DE PRODUCTO — vista completa tipo marketplace =====
   Se abre al dar clic en cualquier tarjeta del catálogo. Trae galería de fotos reales,
   desglose técnico, reputación real del vendedor (Google), compatibilidad por moto y
   productos relacionados calculados del catálogo real.

   Por qué es una ventana y no una página /products/{handle}: los productos siguen sin
   publicarse al canal Tienda en línea (publishedAt: null), así que esa ruta hoy da 404.
   El día que se publiquen, esto se cambia por un enlace real sin tocar el catálogo.

   Tres archivos se cargan bajo demanda, no en cada visita:
     moto-ficha.json     ~210 KB  ficha técnica por SKU
     resenas-google.json   ~2 KB  calificación y opiniones reales del negocio
   fotos.json sí se carga al arranque (~40 KB) porque también alimenta las miniaturas
   de las tarjetas del catálogo. */
(function(){
  var modal = document.getElementById('pdModal');
  if(!modal) return;
  var body = document.getElementById('pdBody'),
      pdScrim = document.getElementById('pdScrim');

  var cache = {};
  function cargar(key, url){
    if(cache[key]) return cache[key];
    cache[key] = fetch(url).then(function(r){ return r.ok ? r.json() : {}; })
                           .catch(function(){ return {}; });
    return cache[key];
  }
  var FOTOS = window.AVANTE_FOTOS || {};

  function abrir(){ modal.classList.add('on'); pdScrim.classList.add('on'); document.body.style.overflow='hidden'; modal.scrollTop = 0; }
  function cerrar(){ modal.classList.remove('on'); pdScrim.classList.remove('on'); document.body.style.overflow=''; }
  document.getElementById('pdClose').addEventListener('click', cerrar);
  pdScrim.addEventListener('click', cerrar);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') cerrar(); });

  var ETIQ = {ic:'Índice de carga', iv:'Índice de velocidad', tl:'Tipo', cn:'Construcción',
              po:'Posición', di:'Dibujo'};

  function estrellas(n){
    var h = '';
    for(var i=1;i<=5;i++){
      var f = n >= i ? 'full' : (n >= i-0.5 ? 'half' : '');
      h += '<span class="star '+f+'">★</span>';
    }
    return h;
  }

  function galeria(fotos, alt){
    if(!fotos || !fotos.length){
      return '<div class="pdgal"><div class="pdmain nofoto">'
        + '<svg viewBox="0 0 120 120"><use href="#tire"/></svg>'
        + '<span>Foto en camino</span></div></div>';
    }
    var thumbs = fotos.length > 1 ? '<div class="pdthumbs">' + fotos.map(function(u,i){
      return '<button class="pdthumb'+(i===0?' on':'')+'" data-foto="'+esc(u)+'"><img src="'+esc(u)+'&width=120"'
        + ' srcset="'+srcset(u,[80,120,180])+'" sizes="60px" alt="" loading="lazy" decoding="async"></button>';
    }).join('') + '</div>' : '';
    return '<div class="pdgal">'
      + '<div class="pdmain"><img id="pdMainImg" src="'+esc(fotos[0])+'&width=900"'
        + ' srcset="'+srcset(fotos[0],[420,640,900,1200])+'"'
        + ' sizes="(max-width:900px) 92vw, 460px"'
        + ' alt="'+alt+'" fetchpriority="high" decoding="async"></div>'
      + thumbs + '</div>';
  }

  /* Relacionados reales, en este orden de prioridad:
     1) misma medida exacta (la sustituta directa)
     2) le queda a alguna de las mismas motos
     3) misma marca de llanta
     Nunca se rellena con productos al azar: si no hay, no se muestra la sección. */
  function relacionados(p){
    var pool = (p.seg === 'moto' ? MOTO : AUTO);
    var vistos = {}, out = [];
    function push(x){ if(x.id!==p.id && !vistos[x.id] && out.length<8){ vistos[x.id]=1; out.push(x); } }
    pool.forEach(function(x){ if(x.s === p.s) push(x); });
    if(p.mb && p.mb.length){
      pool.forEach(function(x){
        if(x.mb && x.mb.some(function(m){ return p.mb.indexOf(m)>=0; })) push(x);
      });
    }
    pool.forEach(function(x){ if(x.b === p.b && x.r === p.r) push(x); });
    return out;
  }

  function pintar(p, f, rev){
    f = f || {}; rev = rev || {};
    var low = p.st <= 2;
    var fotos = FOTOS[p.sk] || [];
    var alt = esc(p.b+' '+p.n+' '+p.s);   /* ya escapado: galeria() lo inserta tal cual */

    /* --- columna de compra --- */
    var compra = '<div class="pdbuycol">'
      + '<span class="pdbrand">'+esc(p.b||'—')+(p.u?' · '+esc(p.u):'')+'</span>'
      + '<h3>'+esc(p.n)+'</h3>'
      + '<span class="pdsize">'+esc(p.s)+'</span>'
      + (rev.calificacion && safeUrl(rev.perfil) ? '<a class="pdrate" href="'+safeUrl(rev.perfil)+'" target="_blank" rel="noopener noreferrer">'
           + '<span class="stars">'+estrellas(rev.calificacion)+'</span>'
           + '<b>'+esc(rev.calificacion)+'</b><span class="n">('+esc(rev.total)+' opiniones del taller en Google)</span></a>' : '')
      + '<div class="pdprice">'
      + (p.pc && p.pc>p.p ? '<span class="antes"><s>'+mx.format(p.pc)+'</s><em>-'+Math.round((1-p.p/p.pc)*100)+'%</em></span>' : '')
      + '<b>'+mx.format(p.p)+'</b><span>precio de <b>1 llanta</b> · IVA incluido · no incluye rin</span></div>'
      + '<span class="pdstock'+(low?' low':'')+'"><i></i>'
      + (low ? 'Últimas '+esc(p.st)+' piezas' : 'En existencia ('+esc(p.st)+')')+' · '+esc(p.suc||'Miramontes')+'</span>'
      + '<div class="pdactions">'
      + '<button class="btn" data-add="'+p.id+'">Agregar al carrito</button>'
      + '<a class="btn ghost" target="_blank" rel="noopener noreferrer" href="'+waLink('Hola Avante, me interesa la llanta '+p.b+' '+p.n+' '+p.s+'. ¿Me confirman disponibilidad y el costo de instalación para mi vehículo?')+'">Preguntar por WhatsApp</a>'
      + '</div>'
      + '<ul class="pdperks">'
      + '<li><b>Recoge e instala el mismo día</b> en Canal de Miramontes 2543, Coyoacán</li>'
      + '<li><b>Envío a toda la República</b> · $150 en CDMX, desde $450 al interior</li>'
      + '<li><b>Montaje y balanceo sin costo</b> con la compra de tus llantas aquí</li>'
      + '<li><b>Producto original</b> de distribuidor autorizado, con garantía de fábrica</li>'
      + '</ul></div>';

    /* --- especificaciones --- */
    var specs = [['Marca', p.b], ['Modelo', p.n], ['Medida', p.s],
                 ['Rin', p.r ? p.r + '"' : ''], ['Uso recomendado', p.u]];
    Object.keys(ETIQ).forEach(function(k){ if(f[k]) specs.push([ETIQ[k], f[k]]); });
    if(p.cc && p.cc.length) specs.push(['Cilindrada compatible', p.cc.join(' · ')]);
    if(p.sk) specs.push(['Código', p.sk]);
    var specHTML = specs.filter(function(x){ return x[1]; }).map(function(x){
      return '<div><dt>'+esc(x[0])+'</dt><dd>'+esc(x[1])+'</dd></div>';
    }).join('');

    var compat = f.mo || p.mo || '';
    var rels = relacionados(p);

    var detalle = '<div class="pdsec"><h4>Ficha técnica</h4><dl class="pdspecs">'+specHTML+'</dl></div>'
      + ((f.dc || f.ft) ? '<div class="pdsec"><h4>Descripción</h4><p class="pdlede">'+esc(f.dc || f.ft)+'</p></div>' : '')
      + (compat ? '<div class="pdsec"><h4>¿A qué moto le queda?</h4>'
          + '<div class="pdchips">'+compat.split(', ').map(function(m){ return '<span class="pdchip">'+esc(m)+'</span>'; }).join('')+'</div>'
          + '<p class="pdnote">Es orientativo por medida. Antes de instalar confirma la medida y los índices que pide tu moto — o pregúntanos por WhatsApp.</p></div>' : '');

    /* --- reputación real del vendedor --- */
    var resenas = '';
    if(rev.calificacion){
      resenas = '<div class="pdsec pdrev"><h4>Lo que dicen del taller</h4>'
        + '<div class="pdrevhead"><div><span class="big">'+esc(rev.calificacion)+'</span>'
        + '<span class="stars">'+estrellas(rev.calificacion)+'</span>'
        + '<span class="n">'+esc(rev.total)+' opiniones en Google</span></div>'
        + (safeUrl(rev.escribir) ? '<a class="btn ghost sm" href="'+safeUrl(rev.escribir)+'" target="_blank" rel="noopener noreferrer">Escribir tu opinión</a>' : '')+'</div>'
        + '<div class="pdrevlist">' + (rev.opiniones||[]).map(function(o){
            return '<blockquote><span class="stars">'+estrellas(o.estrellas)+'</span>'
              + '<p>'+esc(o.texto)+'</p><cite>'+esc(o.autor)+' · '+esc(o.fecha)+'</cite></blockquote>';
          }).join('') + '</div>'
        + '<p class="pdnote">Estas opiniones son del taller Avante Miramontes en Google, no de esta llanta en particular. '
        + (safeUrl(rev.perfil) ? '<a href="'+safeUrl(rev.perfil)+'" target="_blank" rel="noopener noreferrer">Ver las '+esc(rev.total)+' opiniones en Google</a>.' : '')+'</p></div>';
    }

    var relHTML = rels.length ? '<div class="pdsec"><h4>También te puede servir</h4>'
      + '<div class="pdrels">' + rels.map(function(x){
          var xf = (FOTOS[x.sk]||[])[0];
          return '<button class="pdrel" data-goto="'+x.id+'">'
            + '<div class="th">'+(xf ? '<img src="'+esc(xf)+'&width=180" srcset="'+srcset(xf,[120,180,260])+'" sizes="90px" alt="" loading="lazy" decoding="async">'
                                     : '<svg viewBox="0 0 120 120"><use href="'+(x.seg==='moto'?'#tiremoto':'#tire')+'"/></svg>')+'</div>'
            + (x.b ? '<span class="b">'+esc(x.b)+'</span>' : '')+'<span class="n">'+esc(x.n)+'</span>'
            + '<span class="s">'+esc(x.s)+'</span><span class="p">'+mx.format(x.p)+'</span></button>';
        }).join('') + '</div></div>' : '';

    body.innerHTML = '<div class="pdtop">'+galeria(fotos, alt)+compra+'</div>'
      + detalle + resenas + relHTML;
    arriba();
  }

  /* ===== por qué existe arriba() =========================================
     El que scrollea NO es #pdBody: en el CSS, .pdmodal es
     `position:fixed; overflow-y:auto`, y .pdbody sólo es el relleno de adentro.
     Por eso `body.scrollTop = 0` nunca hizo nada — un elemento sin overflow
     tiene scrollTop 0 siempre, y asignarle 0 es una instrucción vacía.

     Se notaba al saltar entre relacionados: la persona bajaba hasta "También te
     puede servir", tocaba otra llanta, el contenido se reemplazaba... y la vista
     seguía a la misma altura, o sea en las reseñas de la llanta nueva. Nunca veía
     la foto ni el precio de lo que acababa de elegir.

     Se pone a 0 en los dos elementos (modal y body) porque el contenedor que
     scrollea depende del ancho de pantalla, y cuesta cero cubrir ambos. */
  function arriba(){
    if(modal.scrollTop) modal.scrollTop = 0;
    if(body && body.scrollTop) body.scrollTop = 0;
  }

  function mostrar(p){
    /* Este es el evento que alimenta el retargeting dinámico: sin él, Meta no sabe
       qué llanta miró la persona y no puede volver a mostrársela en un anuncio. */
    META.track('ViewContent', META.deProducto(p));
    abrir();
    body.innerHTML = '<p class="pdlede" style="padding:40px 0;text-align:center">Cargando ficha…</p>';
    arriba();
    var pRev = cargar('rev', modal.dataset.rev);
    if(p.seg==='moto' && p.sk){
      Promise.all([cargar('ficha', modal.dataset.src), pRev]).then(function(r){
        pintar(p, r[0][p.sk], r[1]);
      });
    } else {
      pRev.then(function(rev){ pintar(p, null, rev); });
    }
  }

  document.addEventListener('click', function(e){
    /* navegar entre relacionados sin cerrar la ficha */
    var rel = e.target.closest('[data-goto]');
    if(rel){
      var q = catMoto.find(rel.dataset.goto) || catAuto.find(rel.dataset.goto);
      if(q) mostrar(q);
      return;
    }
    /* cambiar la foto grande al tocar una miniatura */
    var th = e.target.closest('[data-foto]');
    if(th){
      var img = document.getElementById('pdMainImg');
      if(img) img.src = th.dataset.foto + '&width=900';
      modal.querySelectorAll('.pdthumb').forEach(function(b){ b.classList.remove('on'); });
      th.classList.add('on');
      return;
    }
    /* los controles propios de la tarjeta no deben abrir la ficha */
    if(e.target.closest('[data-add], .add, a, .pdbuycol')) return;
    var card = e.target.closest('.card');
    if(!card) return;
    var btn = card.querySelector('[data-add]');
    var id = btn && btn.dataset.add;
    var p = id && (catMoto.find(id) || catAuto.find(id));
    if(p) mostrar(p);
  });
})();



/* ===== PORTADAS DE SECCIÓN (Moto / Auto) =====
   Cada sección abre en portada — oferta real, tipos, marcas y guías — y el catálogo con
   filtros aparece cuando la persona ya buscó algo. Motivo: caer directo en 369 (o 1,341)
   tarjetas con una barra de filtros enorme no ayuda a nadie a decidir; primero se orienta,
   luego se filtra.

   El contenido NO es decorativo: las ofertas se calculan del descuento real (precio de
   lista contra precio de promoción, campo `pc`), los tipos salen del uso real de la ficha
   técnica y las marcas de moto de la compatibilidad real. Los textos de las guías son las
   respuestas reales que ya da el bot de WhatsApp del negocio. */
(function(){
  var SEC = {
    moto: {land:'motoLand', cat:'motoCat', data:MOTO, cat0:catMoto,
           ofertas:'motoOfertas', usos:'motoUsos', marcas:'motoMarcas'},
    auto: {land:'autoLand', cat:'autoCat', data:AUTO, cat0:catAuto,
           ofertas:'autoOfertas', usos:'autoUsos', marcas:'autoMarcas'}
  };

  function showCat(seg, on){
    var s = SEC[seg]; if(!s) return;
    var land = document.getElementById(s.land), cat = document.getElementById(s.cat);
    if(!land || !cat) return;
    land.hidden = !!on; cat.hidden = !on;
    window.scrollTo({top:0, behavior:'auto'});
    /* Buscar una medida es la señal de intención más fuerte que da el sitio antes
       de agregar al carrito. Con esto Meta puede armar el público "buscó medida". */
    if(on) META.track('Search', {content_category: seg === 'moto' ? 'Moto' : 'Auto y camioneta'});
  }
  window.AVANTE_showCat = showCat;   // lo usa go() al llegar desde el buscador del home

  /* ===== filtros que llegan por la URL =====================================
     Cuando el buscador de la portada ya no puede filtrar en memoria (porque el
     catálogo vive en OTRO documento), navega a /pages/auto?ancho=205&perfil=55&rin=16.
     Aquí se recogen esos parámetros y se aplican como si el usuario los hubiera
     escogido a mano. Efecto lateral bueno: cada búsqueda queda en una URL que se
     puede compartir, guardar en favoritos, y que Google puede rastrear. */
  bloque('filtros-por-url', function(){
    var o = leerFiltrosDeURL();
    if(!o.ancho && !o.perfil && !o.rin && !o.marca && !o.cat && !o.motomarca && !o.cc && !o.q) return;
    var seg = /\/pages\/moto/.test(location.pathname) ? 'moto'
            : /\/pages\/(auto|camioneta)/.test(location.pathname) ? 'auto' : null;
    if(!seg) return;
    var cat = seg === 'moto' ? catMoto : catAuto;
    if(cat.sinVista) return;
    cat.setFrom({
      q: o.q || ((o.ancho && o.perfil) ? o.ancho+'/'+o.perfil : ''),
      rin: o.rin || undefined,
      uso: o.cat || undefined,
      marca: o.marca || undefined,
      motomarca: o.motomarca || undefined,
      cc: o.cc || undefined
    });
    showCat(seg, true);
  });

  function descuento(p){ return p.pc ? Math.round((1 - p.p/p.pc) * 100) : 0; }

  function tarjetaOferta(p){
    var d = descuento(p), foto = (window.AVANTE_FOTOS && window.AVANTE_FOTOS[p.sk] || [])[0];
    return '<article class="card oferta" data-open="'+p.id+'">'
      + '<div class="shot'+(foto?' hasfoto':'')+'">'
      + (d ? '<span class="badge hot">-'+d+'%</span>' : '')
      + (foto ? '<img class="cardfoto" src="'+esc(foto)+'&width=400"'
              + ' srcset="'+srcset(foto,[180,260,400,540])+'"'
              + ' sizes="(max-width:600px) 45vw, 260px"'
              + ' alt="'+esc(p.b+' '+p.n)+'" loading="lazy" decoding="async">'
              : '<svg viewBox="0 0 120 120"><use href="'+(p.seg==='moto'?'#tiremoto':'#tire')+'"/></svg>')
      + '<span class="verdet">Ver detalle</span>'
      + (foto && window.avanteYaMarcada(p.sk) ? '' : '<span class="pza">1 pieza · sin rin</span>')+'</div>'
      + '<div class="body"><span class="brand">'+esc(p.b||'—')+(p.u?' · '+esc(p.u):'')+'</span>'
      + '<span class="name">'+esc(p.n)+'</span><span class="size">'+esc(p.s)+'</span>'
      + '<span class="stock"><i></i>En existencia ('+esc(p.st)+')</span>'
      + '<span class="price">'+(p.pc?'<s>'+mx.format(p.pc)+'</s> ':'')+'<b>'+mx.format(p.p)+'</b><em class="unit">precio por 1 pieza</em></span>'
      + '<button class="add" data-add="'+p.id+'">Agregar</button></div></article>';
  }

  /* Las ofertas se eligen por descuento real, pero exigiendo existencia sana (3+) para no
     mandar a la gente a la última pieza, y sin repetir marca+modelo, para que la fila no
     quede con seis medidas del mismo modelo. */
  function ofertasDe(data){
    var vistos = {};
    return data.filter(function(p){ return descuento(p) >= 10 && p.st >= 3; })
      .sort(function(a,b){ return descuento(b) - descuento(a); })
      .filter(function(p){
        var k = p.b + '|' + p.n;
        if(vistos[k]) return false;
        vistos[k] = 1; return true;
      }).slice(0, 8);
  }

  function pintarSeccion(seg){
    var s = SEC[seg];
    var elOf = document.getElementById(s.ofertas);
    if(elOf) elOf.innerHTML = ofertasDe(s.data).map(tarjetaOferta).join('');

    /* tipos de uso reales, con conteo real */
    var elUso = document.getElementById(s.usos);
    if(elUso){
      var conteo = {};
      s.data.forEach(function(p){ if(p.u) conteo[p.u] = (conteo[p.u]||0)+1; });
      elUso.innerHTML = Object.keys(conteo).sort(function(a,b){ return conteo[b]-conteo[a]; })
        .map(function(u){
          return '<button class="usocard" data-uso="'+seg+'|'+esc(u)+'">'
            + '<svg viewBox="0 0 120 120"><use href="'+(seg==='moto'?'#tiremoto':'#tire')+'"/></svg>'
            + '<b>'+esc(u)+'</b><span>'+conteo[u]+' modelos</span></button>';
        }).join('');
    }

    /* marcas: en moto son marcas de MOTOCICLETA (compatibilidad real); en auto son marcas
       de llanta, que es el dato que existe de ese lado */
    var elMar = document.getElementById(s.marcas);
    if(elMar){
      var m = {};
      if(seg === 'moto') s.data.forEach(function(p){ (p.mb||[]).forEach(function(x){ m[x]=(m[x]||0)+1; }); });
      else s.data.forEach(function(p){ if(p.b) m[p.b]=(m[p.b]||0)+1; });
      elMar.innerHTML = Object.keys(m).sort(function(a,b){ return m[b]-m[a]; }).slice(0,24)
        .map(function(x){
          /* El logo solo se pinta del lado de AUTO, donde el chip es una marca de LLANTA.
             En moto el chip es una marca de MOTOCICLETA (Honda, Yamaha...) y ahi no va logo:
             Avante no distribuye esas marcas. Si no hay logo, queda el texto de siempre. */
          /* auto -> logo de marca de LLANTA; moto -> logo de marca de MOTOCICLETA.
             Son dos mapas distintos a proposito: comparten nombre algunas marcas (Michelin no,
             pero BMW/Honda/Suzuki si existen en los dos mundos) y mezclarlos pondria el logo
             automotriz donde va el de moto. */
          var mapa = (seg === 'auto') ? window.AVANTE_BRAND_LOGOS : window.AVANTE_MOTO_LOGOS;
          var lg = mapa ? mapa[x] : null;
          /* El nombre SIEMPRE se escribe. Cuando hay logo se oculta visualmente con
             .conlogo (sigue ahi para lectores de pantalla y para los bots). Si la imagen
             truena -- CDN lento, archivo borrado, red del cliente -- el onerror quita la
             clase y el nombre vuelve a aparecer. Un chip vacio es peor que un chip de texto. */
          var cara = lg
            ? '<img class="brandlogo" src="'+esc(lg)+'" alt="'+esc(x)+'" loading="lazy" decoding="async"'
              + ' onload="var c=this.parentNode;c&&c.classList.add(\'conlogo\')"'
              + ' onerror="this.remove()">'
              + '<span class="txt">'+esc(x)+'</span>'
            : '<span class="txt">'+esc(x)+'</span>';
          /* Ojo: el chip NO nace con .conlogo. Nace mostrando el nombre y la clase se la pone
             el onload de la imagen. Al reves -- esconder el texto de entrada -- todos los chips
             se veian vacios, con puro numero, mientras las imagenes cargaban en diferido. */
          return '<button class="brandchip" data-marca="'+seg+'|'+esc(x)+'" title="'+esc(x)+'">'+cara+'<small>'+m[x]+'</small></button>';
        }).join('');
    }
  }

  Object.keys(SEC).forEach(pintarSeccion);

  /* ---- buscador de la portada de Moto ---- */
  var mlMarca = document.getElementById('ml-marca'), mlCC = document.getElementById('ml-cc'),
      mlUso = document.getElementById('ml-uso'), mlRin = document.getElementById('ml-rin'),
      mlLlanta = document.getElementById('ml-llanta');
  if(mlMarca){
    fillSelect(mlMarca, catMoto.motoBrandOptions(), {placeholder:'Todas'});
    fillSelect(mlCC, catMoto.ccOptions(), {placeholder:'Todas'});
    var usosM = {}; MOTO.forEach(function(p){ if(p.u) usosM[p.u]=1; });
    fillSelect(mlUso, Object.keys(usosM).sort(), {placeholder:'Todos'});
    var rinM = {}; MOTO.forEach(function(p){ if(p.r) rinM[p.r]=1; });
    fillSelect(mlRin, Object.keys(rinM).map(Number).sort(function(a,b){return a-b;}), {placeholder:'Todos'});
    var marcaM = {}; MOTO.forEach(function(p){ if(p.b) marcaM[p.b]=1; });
    fillSelect(mlLlanta, Object.keys(marcaM).sort(), {placeholder:'Todas'});

    document.getElementById('mlFind').addEventListener('click', function(){
      catMoto.setFrom({motomarca: mlMarca.value, cc: mlCC.value, uso: mlUso.value});
      showCat('moto', true);
    });
    document.getElementById('mlFind2').addEventListener('click', function(){
      catMoto.setFrom({rin: mlRin.value, marca: mlLlanta.value});
      showCat('moto', true);
    });
  }

  /* ---- buscador de la portada de Auto ---- */
  var alAncho = document.getElementById('al-ancho');
  if(alAncho){
    var alPerfil = document.getElementById('al-perfil'), alRin = document.getElementById('al-rin'),
        alMarca = document.getElementById('al-marca'), alCat = document.getElementById('al-cat');
    var anchos={}, perfiles={}, rines={}, marcas={};
    AUTO.forEach(function(p){
      if(p.an) anchos[p.an]=1; if(p.pf) perfiles[p.pf]=1;
      if(p.r) rines[p.r]=1; if(p.b) marcas[p.b]=1;
    });
    var num = function(o){ return Object.keys(o).map(Number).sort(function(a,b){return a-b;}); };
    fillSelect(alAncho, num(anchos), {placeholder:'Cualquiera'});
    fillSelect(alPerfil, num(perfiles), {placeholder:'Cualquiera'});
    fillSelect(alRin, num(rines), {placeholder:'Cualquiera'});
    fillSelect(alMarca, Object.keys(marcas).sort(), {placeholder:'Todas'});

    document.getElementById('alFind').addEventListener('click', function(){
      catAuto.setFrom({
        q: (alAncho.value && alPerfil.value) ? alAncho.value+'/'+alPerfil.value : '',
        rin: alRin.value
      });
      showCat('auto', true);
    });
    document.getElementById('alFind2').addEventListener('click', function(){
      catAuto.setFrom({marca: alMarca.value, uso: alCat.value || undefined});
      showCat('auto', true);
    });
  }

  /* ---- tabs propios de cada portada ---- */
  function tabsDe(attr, panelAttr){
    document.querySelectorAll('['+attr+']').forEach(function(t){
      t.addEventListener('click', function(){
        var cont = t.closest('.finder');
        cont.querySelectorAll('['+attr+']').forEach(function(x){ x.setAttribute('aria-selected','false'); });
        t.setAttribute('aria-selected','true');
        cont.querySelectorAll('['+panelAttr+']').forEach(function(p){
          if(p.getAttribute(panelAttr) === t.getAttribute(attr)) p.setAttribute('data-open','');
          else p.removeAttribute('data-open');
        });
      });
    });
  }
  tabsDe('data-mtab','data-mpanel');
  tabsDe('data-atab','data-apanel');

  /* ---- clics de la portada ---- */
  document.addEventListener('click', function(e){
    var v = e.target.closest('[data-showcat]');
    if(v){ showCat(v.dataset.showcat, true); return; }
    var b = e.target.closest('[data-backland]');
    if(b){ showCat(b.dataset.backland, false); return; }
    var u = e.target.closest('[data-uso]');
    if(u){
      var pu = u.dataset.uso.split('|');
      SEC[pu[0]].cat0.setFrom({uso: pu[1]});
      showCat(pu[0], true); return;
    }
    var m = e.target.closest('[data-marca]');
    if(m){
      var pm = m.dataset.marca.split('|');
      if(pm[0]==='moto') catMoto.setFrom({motomarca: pm[1]});
      else catAuto.setFrom({marca: pm[1]});
      showCat(pm[0], true); return;
    }
    var o = e.target.closest('.oferta[data-open]');
    if(o && !e.target.closest('[data-add]')){
      /* la ficha se abre sola por el listener de .card; aquí sólo se evita que el clic
         en la tarjeta de oferta caiga en otro handler */
      return;
    }
  });
})();


/* ===== PROMOCIONES DE PAR — carrusel automático =====
   Los banners son material real de Avante (los mismos que publican en Instagram) y se
   renuevan mes con mes, en moto y en auto. Por eso esto está armado para que actualizar la
   tanda sea cambiar `assets/promos.js` y subir las imágenes nuevas — nada de tocar HTML.

   El carrusel usa scroll-snap nativo del navegador en vez de una librería:
     · en celular ya se desliza con el dedo, sin escribir una línea de código táctil
     · el scroll es del sistema, así que se siente natural y no pelea con el scroll de la página
     · si el JavaScript falla, las tarjetas siguen ahí y se pueden recorrer a mano
   Encima de eso, el JS agrega el avance automático, los puntos y las flechas.

   Cuidados de accesibilidad y de no molestar:
     · se pausa al pasar el mouse, al enfocar con teclado y cuando la pestaña no está visible
     · se detiene en cuanto la persona toca o desliza — si ya está viendo algo, no se lo movemos
     · respeta "reducir movimiento" del sistema operativo: ahí no avanza solo */
(function(){
  var INTERVALO = 5500;   // ms entre banner y banner. Amaury pidió ~5 s, no 10.

  if(!window.AVANTE_PROMOS) return;
  var PROMOS = window.AVANTE_PROMOS;

  /* La URL del CDN de Shopify no se puede armar concatenando a mano: trae un hash de
     carpeta y un ?v=… de versión. Se toma de un asset que Liquid ya resolvió y se
     sustituye el nombre del archivo.

     🔴 REGRESIÓN DEL 28-AGO, ARREGLADA AQUÍ: esto leía el dato de #promoCarousel, que vive
     DENTRO de la vista Moto. Desde que cada URL sirve sólo su vista, ese elemento no existe
     en el inicio ni en /pages/auto, `base` quedaba en '' y las promociones del inicio salían
     SIN IMAGEN — con la caja negra y el texto alternativo a la vista. Ahora se busca el dato
     en cualquier elemento que lo traiga, y si no hay ninguno se arma desde el src de
     catalog-data.js, que sí está en todas las rutas (el mismo truco que usan los logos de
     marca). Lección: NADA que se necesite en todas las rutas puede depender de un elemento
     que viva dentro de una vista. */
  var elBase = document.querySelector('[data-assetbase]');
  var base = (elBase && elBase.dataset.assetbase)
          || (ASSET_BASE ? ASSET_BASE + 'promo-rosso4-200.jpg' + ASSET_VERSION_QS : '');
  function urlDe(nombre){ return base.replace('promo-rosso4-200.jpg', nombre + '.jpg'); }

  var hoy = new Date(); hoy.setHours(0,0,0,0);
  function vigente(p){
    if(!p.hasta) return true;
    var d = p.hasta.split('-');
    return new Date(+d[0], +d[1]-1, +d[2], 23, 59, 59) >= hoy;
  }
  function fechaLarga(iso){
    var MES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto',
               'septiembre','octubre','noviembre','diciembre'];
    var d = iso.split('-');
    return (+d[2]) + ' de ' + MES[+d[1]-1] + ' de ' + d[0];
  }

  /* 19-sep-2026 — promos POR PIEZA (auto) y existencia.
     Hasta hoy todas las promos eran "por el par" (moto). Las de auto son liquidación por
     pieza ("c/u", últimas N piezas), así que la tarjeta ya no puede decir "por el par" a
     ciegas: es el mismo malentendido del episodio "¿son el par?" pero al revés.
       unidad:"pieza"  -> el precio es de UNA llanta. Sin ese campo, es el par.
       nota            -> renglón corto bajo el precio (piezas que quedan, DOT, qué incluye).
       sku             -> si viene, la promo se oculta sola cuando el catálogo marca 0
                          existencias. Una "última pieza" vendida no debe seguir anunciada. */
  function enCatalogo(sku){
    var L = (window.AVANTE_AUTO || []).concat(window.AVANTE_MOTO || []);
    for(var i = 0; i < L.length; i++){ if(L[i].sk === sku) return L[i]; }
    return null;
  }
  function conExistencia(p){
    if(!p.sku) return true;
    var it = enCatalogo(p.sku);
    return !it || it.st > 0;      // si no se encuentra, no se oculta: mejor mostrar que callar
  }

  function tarjeta(p){
    var porPieza = p.unidad === 'pieza';
    var ahorro = p.suelto && p.suelto > p.precio ? p.suelto - p.precio : 0;
    var msg = porPieza
      ? 'Hola Avante, quiero la promoción de ' + p.marca + ' ' + p.modelo + ' '
        + p.medidas.join(' y ') + ' en ' + mx.format(p.precio) + ' por pieza. ¿Tienen existencia?'
      : 'Hola Avante, quiero la promoción del par ' + p.marca + ' ' + p.modelo + ' '
        + p.medidas.join(' y ') + ' en ' + mx.format(p.precio) + '. ¿Tienen existencia?';
    return '<article class="promocard">'
      + '<a class="promoimg" href="' + waLink(msg) + '" target="_blank" rel="noopener noreferrer">'
      + '<img src="' + esc(urlDe(p.img)) + '&width=620"'
      + ' srcset="' + srcset(urlDe(p.img),[380,620,900]) + '"'
      + ' sizes="(max-width:700px) 88vw, 320px" decoding="async" loading="lazy"'
      + ' alt="Promoción ' + esc(p.marca) + ' ' + esc(p.modelo)
      + ' ' + esc(p.medidas.join(' y ')) + ' por ' + mx.format(p.precio)
      + (porPieza ? ' cada una' : ' el par') + '">'
      + (ahorro ? '<span class="promoahorro">Ahorras ' + mx.format(ahorro) + (porPieza ? ' c/u' : '') + '</span>' : '')
      + '</a>'
      + '<div class="promobody">'
      + '<span class="promomarca">' + esc(p.marca) + ' · ' + esc(p.uso) + '</span>'
      + '<h3>' + esc(p.modelo) + '</h3>'
      + '<span class="promomedidas">' + esc(p.medidas.join('  +  ')) + '</span>'
      + '<div class="promoprecio"><b>' + mx.format(p.precio) + '</b><span>'
      + (porPieza ? 'por llanta · 1 pieza' : 'por el par') + '</span></div>'
      + (ahorro ? '<span class="promosuelto">' + (porPieza ? 'Precio normal ' : 'Suelto costaría ')
                  + '<s>' + mx.format(p.suelto) + '</s></span>'
                : '<span class="promosuelto">Precio de promoción</span>')
      + (p.nota ? '<span class="promonota">' + esc(p.nota) + '</span>' : '')
      + '<div class="promoacc">'
      + '<a class="btn wa sm" href="' + waLink(msg) + '" target="_blank" rel="noopener noreferrer">Pedir por WhatsApp</a>'
      + '<button class="btn ghost sm" data-vermedida="' + esc(p.medidas[0]) + '" data-seg="' + esc(p.seg || 'moto') + '">'
      + (porPieza ? 'Ver esa medida' : 'Ver esas medidas') + '</button>'
      + '</div></div></article>';
  }

  /* ---- motor del carrusel ---- */
  function Carrusel(cont, lista){
    if(!cont || !lista.length) return null;
    var track = cont.querySelector('.cartrack');
    var dots  = cont.querySelector('.cardots');
    var prev  = cont.querySelector('.carnav.prev');
    var next  = cont.querySelector('.carnav.next');
    track.innerHTML = lista.map(tarjeta).join('');
    var cards = [].slice.call(track.children);
    var timer = null, pausado = false, tocado = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Cuántas tarjetas caben a la vez depende del ancho real, no de un breakpoint fijo:
       así el número de puntos siempre corresponde a lo que de verdad se ve. */
    function porPagina(){
      if(!cards.length) return 1;
      var anchoCard = cards[0].getBoundingClientRect().width + 16;
      return Math.max(1, Math.round(track.clientWidth / anchoCard));
    }
    function paginas(){ return Math.max(1, Math.ceil(cards.length / porPagina())); }
    function pagActual(){
      var pp = porPagina();
      if(!cards.length) return 0;
      var ancho = cards[0].getBoundingClientRect().width + 16;
      return Math.min(paginas() - 1, Math.round(track.scrollLeft / (ancho * pp)));
    }

    function pintarDots(){
      var n = paginas();
      if(n <= 1){ dots.innerHTML = ''; cont.classList.add('sinnav'); return; }
      cont.classList.remove('sinnav');
      var act = pagActual();
      dots.innerHTML = Array.from({length:n}, function(_, i){
        return '<button role="tab" aria-label="Promoción ' + (i+1) + ' de ' + n + '"'
             + (i === act ? ' aria-selected="true" class="on"' : ' aria-selected="false"')
             + ' data-pag="' + i + '"></button>';
      }).join('');
    }

    function irA(pag, suave){
      var pp = porPagina(), n = paginas();
      pag = ((pag % n) + n) % n;                   // envuelve: del último vuelve al primero
      var ancho = cards[0].getBoundingClientRect().width + 16;
      track.scrollTo({left: pag * ancho * pp, behavior: suave === false ? 'auto' : 'smooth'});
    }

    function arrancar(){
      if(reduce || timer) return;
      timer = setInterval(function(){
        if(pausado || tocado || document.hidden) return;
        irA(pagActual() + 1);
      }, INTERVALO);
    }
    function detenerDeVerdad(){ tocado = true; }   // la persona tomó el control

    cont.addEventListener('mouseenter', function(){ pausado = true; });
    cont.addEventListener('mouseleave', function(){ pausado = false; });
    cont.addEventListener('focusin',   function(){ pausado = true; });
    cont.addEventListener('focusout',  function(){ pausado = false; });
    track.addEventListener('pointerdown', detenerDeVerdad);
    track.addEventListener('wheel', detenerDeVerdad, {passive:true});

    var raf;
    track.addEventListener('scroll', function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        var act = pagActual();
        [].forEach.call(dots.children, function(b, i){
          b.classList.toggle('on', i === act);
          b.setAttribute('aria-selected', i === act ? 'true' : 'false');
        });
      });
    }, {passive:true});

    if(prev) prev.addEventListener('click', function(){ detenerDeVerdad(); irA(pagActual() - 1); });
    if(next) next.addEventListener('click', function(){ detenerDeVerdad(); irA(pagActual() + 1); });
    dots.addEventListener('click', function(e){
      var b = e.target.closest('[data-pag]');
      if(b){ detenerDeVerdad(); irA(+b.dataset.pag); }
    });

    var t;
    window.addEventListener('resize', function(){
      clearTimeout(t); t = setTimeout(pintarDots, 180);
    });

    pintarDots();
    arrancar();
    return {repintar: pintarDots};
  }

  /* ---- montaje por segmento ---- */
  function montar(seg, contId, secId, vigId, promos){
    var vivas = promos.filter(vigente).filter(conExistencia);
    var sec = document.getElementById(secId);
    if(!vivas.length){ if(sec) sec.hidden = true; return; }
    if(sec) sec.hidden = false;
    Carrusel(document.getElementById(contId), vivas);

    var vig = document.getElementById(vigId);
    if(vig){
      var fin = vivas.map(function(p){ return p.hasta; }).sort()[0];
      var dias = Math.ceil((new Date(fin + 'T23:59:59') - hoy) / 86400000);
      /* Desde el 19-sep el banner web va SIN la franja legal impresa (traía fechas viejas o
         inexistentes), así que ESTE texto es el que lleva las condiciones completas. Si se
         toca, que siga diciendo las cuatro: vigencia, existencias, MSI y cambios. */
      vig.innerHTML = (seg === 'auto'
          ? 'Precio por llanta (una pieza), en la sucursal de Miramontes. '
          : 'Precio por el par de llantas, montadas en la sucursal de Miramontes. ')
        + '<b>Vigente hasta el ' + fechaLarga(fin) + ' o hasta agotar existencias</b>'
        + (dias <= 10 ? ' — quedan ' + dias + (dias === 1 ? ' día' : ' días') : '')
        + '. No aplican meses sin intereses, no hay cambios ni devoluciones y no se acumula'
        + ' con otros descuentos u ofertas.';
    }
  }

  var deMoto = PROMOS.filter(function(p){ return (p.seg || 'moto') === 'moto'; });
  var deAuto = PROMOS.filter(function(p){ return p.seg === 'auto'; });

  montar('moto', 'promoCarousel',     'promosSec',     'promoVig',     deMoto);
  montar('auto', 'promoCarouselAuto', 'promosSecAuto', 'promoVigAuto', deAuto);

  /* En el inicio se muestran las de moto y las de auto juntas, hasta 6. */
  /* 19-sep: con 18 promos de moto, `concat().slice(0,6)` dejaba a las de auto fuera del
     inicio para siempre. Ahora: hasta 2 de auto y el resto de moto, intercaladas. */
  var hMoto = deMoto.filter(vigente).filter(conExistencia);
  var hAuto = deAuto.filter(vigente).filter(conExistencia).slice(0, 2);
  var enHome = hMoto.slice(0, 6 - hAuto.length);
  hAuto.forEach(function(p, i){ enHome.splice(Math.min(enHome.length, 2 + i * 3), 0, p); });
  if(enHome.length){
    Carrusel(document.getElementById('homePromoCarousel'), enHome);
  } else {
    var hs = document.getElementById('homePromosSec');
    if(hs) hs.hidden = true;
  }

  /* "Ver esas medidas": lleva al catálogo filtrado por la medida delantera. */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-vermedida]');
    if(!b) return;
    var seg = b.dataset.seg || (b.closest('#promoCarouselAuto') ? 'auto' : 'moto');
    (seg === 'auto' ? catAuto : catMoto).setFrom({q: b.dataset.vermedida});
    go(seg);
    if(window.AVANTE_showCat) window.AVANTE_showCat(seg, true);
  });
})();


})();
